export default [["en-us", {
  "availability": {
    "after4pm": "After 4 pm",
    "afternoons": "Afternoons",
    "availabilityOn": "Availability on",
    "before12pm": "Before 12 pm",
    "between12And4pm": "12 pm - 4 pm",
    "change": "Change",
    "displaying": "Displaying",
    "evenings": "Evenings",
    "filterAvailability": "Filter availability",
    "mornings": "Mornings",
    "showAvailabilityFor": "Show availability for:",
    "timezoneModal": {
      "cancel": "Cancel",
      "description": "Select which timezone to display appointment times below.",
      "title": "Change timezone",
      "update": "Update"
    },
    "viewingIn": "Viewing in"
  },
  "billing": {
    "actions": {
      "back": "Back",
      "cancel": "Cancel",
      "confirm": "Confirm",
      "continue": "Continue",
      "download": "Download",
      "pay": "Pay",
      "payNow": "Pay now",
      "review": "Review",
      "submit": "Submit",
      "submitClaim": "Submit claim"
    },
    "components": {
      "cardForm": {
        "cardholderName": "Cardholder's name",
        "namePlaceholder": "Name as shown on the card"
      },
      "oonBanner": {
        "contactClinician": "Reach out to your clinician for additional assistance",
        "viewStatement": "View insurance reimbursement statement."
      },
      "outOfNetwork": {
        "acknowledgment": "I authorize SimplePractice to submit this out-of-network claim to my insurance payer on my behalf. I understand that I am responsible for payment of my account, and SimplePractice cannot accept responsibility for negotiating a settlement on a disputed claim or financial responsibility for a denied claim.",
        "appointmentInfo": "Appointment info",
        "appointmentInfoHelp": "To update your appointment info, contact your practitioner",
        "back": "Back",
        "breadcrumb": "Billing & Payments",
        "hideAll": "Hide all",
        "serviceDetails": "Service details",
        "showAll": "Show all",
        "title": "Out-of-network claim",
        "totalFees": "Total Fees",
        "totalPaid": "Total Paid"
      },
      "paymentMethods": {
        "addNewCard": "Add new card",
        "cardsOnFile": "Cards on File ({count})",
        "changeDefaultCard": "Change default card",
        "changeDefaultCardMessage": "Your {brand} ending in {last4} will become your default card.",
        "confirm": "Confirm",
        "defaultCard": "Default Card",
        "defaultCardTooltip": "All payments will be charged to this card unless you manually change the payment method.",
        "newCard": "+ New card",
        "noCards": "There are no cards on file"
      },
      "paymentModal": {
        "cancel": "Cancel",
        "makeDefault": "Make default"
      },
      "tables": {
        "amount": "Amount",
        "appointment": "Appointment",
        "balance": "Balance",
        "charges": "Charges",
        "claimStatus": "Claim Status",
        "date": "Date",
        "details": "Details",
        "payments": "Payments",
        "paymentsTooltip": "Your clinician has recorded payments you've made, but they have not been applied to an invoice yet.",
        "total": "Total",
        "totalBalance": "Total Balance",
        "totalCharges": "Total Charges",
        "type": "Type",
        "viewAll": "View All"
      },
      "tabs": {
        "accountHistory": "Account History",
        "billingDocuments": "Billing Documents",
        "insurance": "Insurance",
        "paymentHistory": "Payment History",
        "paymentMethods": "Payment Methods"
      }
    },
    "coverage": {
      "appointment": "appointment",
      "appointments": "appointments",
      "willCover": "{channelName} will cover {count} more {appointments}"
    },
    "documents": {
      "insurance": "Insurance",
      "insuranceForm": "Insurance form",
      "insuranceInfo": "Insurance info",
      "insuranceReimbursementStatements": "Insurance Reimbursement Statements",
      "invoices": "Invoices",
      "outOfNetworkClaims": "Out-of-Network Claims",
      "receipts": "Receipts",
      "statements": "Statements"
    },
    "empty": {
      "noClaims": "No out of network claims",
      "noDocuments": "No documents",
      "noHistory": "No history",
      "noInvoices": "No invoices",
      "noPendingInvoices": "No pending invoices."
    },
    "errors": {
      "appointmentBalance": "Pay ${amount} appointment balance to submit claim",
      "appointmentBalanceHelp": "To submit an out-of-network claim, the appointment can't have an outstanding balance",
      "claimsNotLoaded": "Out of network claims could not be loaded.",
      "couldNotAddCard": "Could not add a card",
      "documentsNotLoaded": "Documents could not be loaded.",
      "historyNotLoaded": "History could not be loaded.",
      "payBalance": "Pay ${amount} balance",
      "paymentCouldNotBeProcessed": "Your payment could not be processed",
      "technicalIssue": "There's a technical issue on our end. Wait a few minutes, then try again.",
      "updateInsurance": "Update insurance info to continue",
      "updateInsuranceButton": "Update insurance info"
    },
    "filters": {
      "allInvoices": "Filter: All Invoices",
      "paidInvoices": "Paid Invoices",
      "pastDueInvoices": "Past Due Invoices",
      "unpaidInvoices": "Unpaid Invoices"
    },
    "financial": {
      "amountDue": "Amount Due",
      "totalBalance": "Total Balance"
    },
    "forms": {
      "requiredInformation": "*Required information"
    },
    "insurance": {
      "company": "Insurance Company",
      "coverageEndDate": "Coverage End Date",
      "coverageStartDate": "Coverage Start Date",
      "form": {
        "searchPlaceholder": "Search for insurance company"
      },
      "groupId": "Group ID",
      "memberId": "Member ID",
      "placeholders": {
        "city": "City",
        "firstName": "First Name",
        "groupId": "Group ID (optional)",
        "lastName": "Last Name",
        "memberId": "Member ID",
        "planId": "Plan ID (optional)",
        "state": "State",
        "streetAddress": "Street Address",
        "zipCode": "Zip Code"
      },
      "planId": "Plan ID",
      "policyHolderAddress": "Policy Holder Address",
      "policyHolderBirthDate": "Policy holder birth date",
      "policyHolderFirstName": "Policy holder legal first name",
      "policyHolderLastName": "Policy holder legal last name",
      "policyHolderNameTooltip": "This should be their name as displayed on the insurance card",
      "policyHolderPhone": "Policy Holder Phone",
      "primaryPolicyHolder": "Primary Policy Holder",
      "relations": {
        "other": "Other",
        "parent": "Parent",
        "self": "Self",
        "spouse": "Spouse"
      },
      "sex": {
        "female": "Female",
        "label": "Policy holder sex",
        "male": "Male"
      },
      "success": {
        "insuranceUpdated": "Insurance information saved successfully"
      }
    },
    "messages": {
      "balanceQuestions": "If you have questions about this balance, contact your practitioner.",
      "loading": "Loading...",
      "partialPayments": "You can now make partial payments toward your balance"
    },
    "pageTitle": "Billing & Payments",
    "pages": {
      "addInsurance": "Add Insurance",
      "allInsuranceClaims": "All Out of network insurance claims",
      "allInvoices": "All Invoices",
      "allReceipts": "All Receipts",
      "allStatements": "All Statements",
      "allSuperbills": "All Insurance Reimbursement Statements",
      "billingAndPayments": "Billing & Payments",
      "insuranceDetails": "Insurance Details",
      "outOfNetworkClaim": "Out-of-network Claim"
    },
    "paymentMethods": {
      "addNewCard": "Add card",
      "cardAddError": "Card could not be added",
      "defaultCard": "Default",
      "defaultCardAdded": "Default card added",
      "defaultCardUpdateError": "Default card could not be updated",
      "defaultCardUpdated": "Default card updated",
      "makeDefault": "Make default",
      "newCardAdded": "New card added",
      "otherAmount": "Other amount",
      "saveCard": "Save",
      "saveNewCard": "Save card",
      "savedCards": "Saved Cards"
    },
    "paymentModal": {
      "actions": {
        "pay": "Pay",
        "print": "Print"
      },
      "amount": {
        "creditSuffix": " (credit)",
        "totalAccountBalance": "Total account balance:"
      },
      "makeCheckPayable": "Make check payable to",
      "makePayment": "Make a payment",
      "otherPaymentMethods": "Other payment methods",
      "payWithCard": "Pay with card",
      "paymentsSecured": "Payments secured by",
      "selectPaymentAmount": "Select payment amount"
    },
    "sections": {
      "invoices": "Invoices",
      "outOfNetworkClaims": "Out of network claims",
      "receipts": "Receipts",
      "statements": "Statements",
      "superbills": "Insurance Reimbursement Statements"
    },
    "states": {
      "fileClaim": "File a claim",
      "loading": "Loading...",
      "loadingClaims": "Loading Claims...",
      "loadingHistory": "Loading History...",
      "preparingClaim": "Preparing claim... This might take up to a minute.",
      "retry": "Retry",
      "submittingClaim": "Submitting claim... This might take up to a minute.",
      "totalBalance": "Total Balance",
      "unableToLoad": "Unable to load additional payment methods",
      "viewClaim": "View claim",
      "youHaveCredit": "You have a credit of"
    },
    "success": {
      "contactProviderForInfo": "Contact your provider for more information.",
      "paymentCouldNotBeMade": "Payment could not be made",
      "paymentCouldNotBeProcessedTitle": "Your payment could not be processed",
      "paymentMadeSuccessfully": "Payment made successfully."
    }
  },
  "booking": {
    "actions": {
      "continueAndReview": "Continue & Review",
      "more": "MORE",
      "next": "Next",
      "requestAppointment": "Request appointment",
      "skip": "Skip"
    },
    "calendar": {
      "afternoon": "Afternoon",
      "days": {
        "friday": "Fri",
        "monday": "Mon",
        "saturday": "Sat",
        "sunday": "Sun",
        "thursday": "Thu",
        "tuesday": "Tue",
        "wednesday": "Wed"
      },
      "evening": "Evening",
      "months": {
        "april": "April",
        "august": "August",
        "december": "December",
        "february": "February",
        "january": "January",
        "july": "July",
        "june": "June",
        "march": "March",
        "may": "May",
        "november": "November",
        "october": "October",
        "september": "September"
      },
      "morning": "Morning"
    },
    "clientType": {
      "careCoordinator": {
        "member": "My member",
        "memberAndPartner": "My member and partner",
        "memberOnBehalf": "My member on behalf of someone else"
      },
      "contact": "Someone else",
      "couple": "My partner and me",
      "me": "Me",
      "messages": {
        "allTypes": "You can request this appointment for yourself, on behalf of someone else, or for both you and your partner. Please choose below.",
        "careCoordinator": "Please choose from the options below.",
        "clientContact": "You can request this appointment for yourself or on behalf of someone else. Please choose below.",
        "clientCouple": "You can request this appointment for yourself, or for both you and your partner. Please choose below.",
        "contactCouple": "You can request this appointment on behalf of someone else or for both you and your partner. Please choose below."
      },
      "select": "Next",
      "title": "Who is this appointment for?"
    },
    "date": {
      "availability": "Availability on {month}",
      "noAvailability": "Sorry, there's no availability for this service at the location you've selected.",
      "tryDifferentLocation": "Try a different location"
    },
    "information": {
      "appointmentRequestsWillBeConfirmed": "Appointment requests will be confirmed by the practice",
      "careCoordinatorInstructions": "Enter the name, email, and phone number of the person you are requesting an appointment on behalf of. The email and phone number will be used to send appointment confirmations and reminders.",
      "contactInformation": "Contact information",
      "dateOfBirth": "Date of birth",
      "email": "Email",
      "emergencyNotice": "If you or others are in immediate danger or experiencing a medical emergency, call 911 immediately",
      "howDoYouPlanToPay": "How do you plan to pay for care?",
      "insurance": {
        "backOfInsuranceCard": "Back of insurance card",
        "downloadHere": "download it here",
        "dropFilesHere": "Drop files here to attach",
        "frontOfInsuranceCard": "Front of insurance card",
        "insuranceCard": "Insurance card",
        "onlyFileTypes": "Only JPG, PNG, & PDF files",
        "previewUnavailable": "Preview is unavailable.",
        "remove": "Remove",
        "toViewFile": "To view file,",
        "uploadInsuranceCard": "Upload an image of the front and back of your insurance card",
        "uploadSuccessful": "Upload Successful"
      },
      "insuranceOption": "Insurance",
      "legalFirstName": "Legal first name",
      "legalLastName": "Legal last name",
      "nameYouGoBy": "Name you go by",
      "noAnswer": "No answer",
      "outOfPocket": "Out of pocket",
      "phone": "Phone",
      "thisWillOnlyBeShared": "This will only be shared with the practice",
      "tooltips": {
        "useInsuranceName": "Use the name on your insurance card."
      }
    },
    "location": {
      "select": "Select"
    },
    "message": {
      "additionalInfo": "Additional info (optional)",
      "additionalInfoSubtitle": "Share more details with this clinician to help them respond to your request. Only share what you're comfortable with. Your responses will be passed securely.",
      "disclaimers": {
        "reorderedNav": "By submitting the optional information above, you agree that you may be providing protected health information (\"PHI\") to the therapist and team members in their practice. You release SimplePractice (website provider) from any liability associated with disclosure of PHI by the recipient or in transmission.",
        "therapyFinder": "By sending message, you agree that you may be providing personal health information (\"PHI\"). Therapy Finder (website provider) cannot guarantee that such information will remain private, as this is the responsibility of recipient. You release Therapy Finder from any liability associated with disclosure of PHI by recipient."
      },
      "emergencyNotice": "In the event of an emergency, do not request an appointment online. If you are experiencing a medical emergency, or thinking about suicide or harming yourself or others, call 911 immediately or another applicable emergency number.",
      "fireWarning": "Let your therapist know if you've been impacted by the fires in Los Angeles",
      "forExample": "For example: what you'd like to focus on, insurance or payment questions, etc.",
      "isThereAnythingElse": "Is there anything else you'd like the practitioner to know?",
      "limitedTo600Characters": "Limited to 600 characters",
      "message": "Message",
      "optional": "Optional",
      "selectAllThatApply": "Select all that apply",
      "selectUpTo3": "Select up to 3 from the following options",
      "useThisSpace": "Use this space to share a bit about what brought you here today, what you'd like to focus on, ask any insurance or payment questions, or include anything else you want the therapist to know.",
      "whatIsYourHistory": "What is your history with mental health?",
      "whatKindOfCare": "What kind of care are you looking for?",
      "whyAreYouSeekingCare": "Why are you seeking care?"
    },
    "prescreener": {
      "categories": {
        "administrative": "Administrative",
        "billingAndPayment": "Billing & Payment",
        "clientPreferences": "Client Preferences",
        "demographics": "Demographics",
        "reasonForCare": "Reason for care"
      },
      "insurance": {
        "back": {
          "ofYourCard": "Back of your card",
          "title": "Back of insurance card"
        },
        "front": {
          "ofYourCard": "Front of your card",
          "title": "Front of insurance card"
        }
      },
      "legalWarning": "If you or others are in immediate danger or experiencing a medical emergency, call 911 immediately.",
      "phiNotice": "By completing and submitting the optional information above, you agree that you may be providing protected health information (\"PHI\"). Monarch (website provider) can never guarantee that such information will remain private. To the fullest extent permitted by law, you release Monarch from any liability associated with disclosure of PHI, including, but not limited to, by the recipient or in transmission. Please note, the information you submit may be viewable to team members in this practice.",
      "questions": {
        "file": {
          "forDesktop": {
            "primary": "Choose file",
            "secondary": " or drag and drop file"
          },
          "forMobile": {
            "primary": "Upload a file",
            "secondary": " or take a picture"
          }
        },
        "sex": {
          "subtext": "For insurance verification"
        },
        "state": {
          "subtext": "Select the state you live in"
        }
      },
      "validations": {
        "dateOfBirth": "Please enter a valid date of birth",
        "file": "Please upload the front and back of your insurance card",
        "maxLength": "Limited to {maxLength} characters",
        "multiselect": {
          "default": "This can't be blank. Select all that apply",
          "hint": "This can't be blank."
        },
        "select": "This field can't be blank",
        "state": "This field can't be blank. Select the state you live in",
        "string": "This field can't be blank",
        "text": "This field can't be blank"
      }
    },
    "requestAnAppointment": "Request an appointment",
    "review": {
      "completedStep": "Completed step",
      "dateTime": "Date & Time",
      "location": "Location",
      "service": "Service",
      "subtitle": "Note: Appointment requests will be confirmed by the practice. Tap Request appointment below to finish.",
      "title": "Almost done!"
    },
    "service": {
      "recommended": "Recommended",
      "select": "Select"
    },
    "steps": {
      "clientType": "Select client",
      "clientTypes": {
        "contact": "Contact",
        "couple": "Couple",
        "individual": "Individual"
      },
      "clinician": "Choose clinician",
      "completedTitles": {
        "client": "Client",
        "clinician": "Clinician",
        "contactInformation": "Contact information",
        "dateTime": "Date & time",
        "location": "Location",
        "memberInformation": "Member's information",
        "service": "Service"
      },
      "condensed": {
        "additionalInfo": "Additional info",
        "appointmentInfo": "Appointment info",
        "optional": "(optional)",
        "prescreener": "Prescreener",
        "reasonForVisit": "Reason for visit",
        "yourInfo": "Your info"
      },
      "contactInformation": "Contact information",
      "date": "Select date & time",
      "externalDetails": "External details",
      "intakeDocuments": "Intake documents",
      "loading": {
        "availability": "availability",
        "clinicians": "clinicians",
        "locations": "locations",
        "services": "services"
      },
      "location": "Select location",
      "message": "Message",
      "requestCancelled": "Request cancelled",
      "requestSent": "Request sent",
      "reviewConfirm": "Review & confirm",
      "service": "Select service",
      "unavailable": "Unavailable"
    },
    "unavailable": {
      "callNow": "Call now to schedule a session: {phone}.",
      "contactDirectly": "Contact your practitioner directly about scheduling.",
      "problem": "There was a problem completing your request.",
      "title": "Contact your practitioner"
    },
    "widget": {
      "signIn": {
        "alreadyClient": "Already a client?",
        "signIn": "Sign In",
        "toRequest": "To request an appointment,"
      },
      "title": "Request an appointment"
    }
  },
  "cancelled": {
    "appointmentCancelled": "Your appointment has been cancelled.",
    "bookNewAppointment": "Book a new appointment"
  },
  "channelFields": {
    "externalReferenceId": "External reference ID",
    "referenceTooltip": "Include a reference ID to associate requests to an external system. Ignore if you do not have a reference number",
    "subtitle": "The information below can be used to associate your appointment requests to an external system.",
    "title": "Optionally enter an external reference number"
  },
  "channelUploads": {
    "acceptedFileTypes": "Accepted file types: pdf, doc, docx",
    "dragAndDrop": "or drag and drop",
    "dropText": "Drop files here to attach",
    "invalidText": "Invalid selection, please upload a pdf, doc or docx",
    "subtitle": "Complete and upload the intake form below to speed up the clinician's intake process.",
    "title": "Optionally upload documents to share with the clinician",
    "uploadFile": "Upload file"
  },
  "clientAttendance": {
    "actions": {
      "addToCalendar": "Add to Calendar",
      "cancelAppointment": "Cancel Appointment",
      "confirmAttendance": "Yes, I'll be there"
    },
    "alert": {
      "title": "An error has occurred"
    },
    "errors": {
      "appointmentDeleted": "This appointment has been deleted or does not exist",
      "connectionError": "Please check your connection and refresh the page",
      "linkExpired": "This link is no longer valid. The appointment has passed."
    },
    "labels": {
      "options": "Options:",
      "when": "When:",
      "where": "Where:",
      "with": "With:"
    },
    "modals": {
      "cancel": {
        "confirmButton": "Yes, Cancel",
        "confirmationMessage": "Are you sure you want to cancel? After cancelling, no further changes can be made to this appointment.",
        "maxChars": "{count} max characters",
        "reasonLabel": "Reason for cancelling",
        "reasonPlaceholder": "Ex. I had a work conflict.",
        "title": "Cancel Appointment",
        "windowPassed": "The cancellation window has passed. Please call {phone} to cancel."
      },
      "status": {
        "dismiss": "Dismiss"
      }
    },
    "notices": {
      "telehealthLink": "The link to join your Telehealth appt will be included."
    },
    "status": {
      "appointmentCancelled": "Appointment Cancelled",
      "appointmentConfirmed": "Appointment Confirmed"
    }
  },
  "confirmation": {
    "addToCalendar": "Add to Calendar",
    "apple": "Apple",
    "bookNewAppointment": "Book a new appointment",
    "cancelAppointment": "Cancel Appointment",
    "contact": "Contact",
    "done": "Done",
    "google": "Google",
    "outlook": "Outlook",
    "thankYou": {
      "appointmentRequested": "Your appointment has been requested",
      "appointmentRequestedSubmessage": "We have sent a confirmation and details to your email.",
      "careCoordinatorConfirmation": "We will send you a confirmation after your appointment has been confirmed.",
      "careCoordinatorRequestSent": "Your appointment request has been sent.",
      "existingClientConfirmation": "Your appointment is not confirmed until you get an email saying that your request has been accepted.",
      "newClientConfirmation": "You'll get an email with the details of your requested appointment. Your appointment is not confirmed until you get another email saying that your request has been accepted."
    },
    "what": "What",
    "when": "When",
    "where": "Where",
    "who": "Who",
    "with": "With"
  },
  "consent": {
    "contactConsent": "By requesting an appointment, you consent to being contacted by this practice or SimplePractice via email, phone, voicemail, or text.",
    "dataProcessingConsent": "By submitting this form, you agree to the processing of your sensitive personal information, which may include protected health information (PHI). This information may be viewed by team members in this practice.",
    "requestConfirmation": "Appointment requests will be confirmed by the practice"
  },
  "contact": {
    "clientInfo": "Client's info",
    "completedStep": "Completed step",
    "dateOfBirth": "Date of birth",
    "email": "Email",
    "emergencyWarning": "If you or others are in immediate danger or experiencing a medical emergency, call 911 immediately.",
    "firstName": "First name",
    "gender": "Gender",
    "isClientMinor": "Is the client a minor?",
    "isThereAnything": "Is there anything else you want to share?",
    "lastName": "Last name",
    "limitedTo600": "Limited to 600 characters",
    "messageExample": "For example: what you'd like to focus on, insurance or payment questions, etc.",
    "messageSentTo": "Your message has been sent to {practiceName}",
    "nameYouGoBy": "Name you go by",
    "no": "No",
    "partnerInfo": "Partner's info",
    "phone": "Phone",
    "select": "Select",
    "selectState": "Select the state you live in",
    "sendMessage": "Send Message",
    "state": "State",
    "whoReceivingCare": "Who would be receiving care?",
    "yes": "Yes",
    "yourInfo": "Your info"
  },
  "dateCalendar": {
    "nextMonth": "Next month",
    "previousMonth": "Previous month"
  },
  "documents": {
    "emptyState": {
      "noPendingDocuments": "No pending documents at this time."
    }
  },
  "emc": {
    "away_message_customizer": {
      "customize": "Customize",
      "description": "Let your clients know to expect a delayed response when they message you in the Client Portal.",
      "input_label": "Message",
      "input_placeholder": "Start note...",
      "learn_more": "Learn more",
      "message_required": "A message is required",
      "retry_button": "Retry",
      "save_button": "Save",
      "title": "Customize Your Away Message",
      "unsaved_changes": "You have unsaved changes",
      "update_failed": "Something went wrong on our end.",
      "update_success": "Away message updated successfully"
    },
    "away_status": {
      "false": "off",
      "indicator": "(Away)",
      "status_text_prefix": "Away message to clients is",
      "true": "on",
      "update_failed": "Failed to update your away status. Please try again.",
      "update_success": "Away message turned {status}"
    },
    "contact_list_item": {
      "select_aria_label": "Select {userNames} to start a conversation"
    },
    "contacts_page": {
      "clear_search": "Clear search",
      "infinity_loader_label": "Load more contacts",
      "list": "Contact list",
      "loading": "Loading contacts",
      "new_message": "New message",
      "no_contacts_found": "No contacts found",
      "recent_conversations": "Recent conversations",
      "search_help_text": "Search for contacts by name to start a new conversation",
      "search_input_label": "To:",
      "search_placeholder": "Search for a client, a contact, or a team member"
    },
    "device_offline_error": "Your device seems to be offline, so sending messages won't work at the moment. We'll keep trying to reconnect, or you can retry.",
    "disabled_conversation_error": "Something went wrong on our end. Please refresh the page.",
    "draft_indicator": "[Draft]",
    "empty_list_header": "Welcome to Secure Messaging",
    "empty_list_text": "You don't have any conversations yet",
    "general_error": "Something went wrong on our end. Please try again.",
    "message_placeholder": "Send a message",
    "message_status": {
      "delivered": "Delivered",
      "failed": "Failed to send. Click to retry",
      "sending": "Sending..."
    },
    "navigation": {
      "conversation_list": "Secure messages {amount, plural, =0 {} other {({amount})}}"
    },
    "new_line_hint": {
      "effect": "to add a new line",
      "keys": "Shift + Return"
    },
    "read_at": {
      "before_today": "Read {date} at {time}",
      "before_today_couple": "Read by {name} {date} at {time}",
      "today": "Read at {time}",
      "today_couple": "Read by {name} at {time}"
    },
    "retry_connection": "Retry connection",
    "send": "Send",
    "start_conversation_callout": "Start a secure conversation with {name}",
    "start_conversation_header": "Start a secure conversation",
    "truncated_system_message": {
      "footer": "Your Account Owner can request a Data Export at any time from their account, contact them for more information.",
      "text": "Your Messaging history with this client prior to {date} is available via the Practice Data Export. {footer}"
    },
    "truncated_text": {
      "show_less": "Show less",
      "show_more": "Show more"
    },
    "unread_message_indicator": "Unread message indicator"
  },
  "errors": {
    "403": {
      "message": "Your SimplePractice user account does not have the necessary permission to access this page. If you believe you should have access, please contact your account administrator.",
      "title": "You do not have permission to access this page."
    },
    "404": {
      "message": "We can't find the page you're looking for, but we can help you find your way home.",
      "messageNoPractice": "We can't find the page you're looking for.",
      "title": "This page seems to be missing"
    },
    "500": {
      "message": "An unexpected error occurred. We have been notified of the error and are actively looking into it. This is a priority to resolve. Please try your request again in a few minutes.",
      "title": "An unexpected system error occurred."
    },
    "actions": {
      "errorCode": "Error code: {code}",
      "retry": "Retry",
      "takeHome": "Take me home"
    },
    "appointment": {
      "duplicateEmail": {
        "coupleMessage": "The same email address cannot be used for both individuals. Please provide different email addresses for each person.",
        "minorMessage": "The same email address cannot be used for both individuals. Please provide different email addresses for each person.",
        "title": "Duplicate Email"
      },
      "emailInUse": {
        "message": "Email is already in use. If this is your email,",
        "messageWithPhone": "Email is already in use. If this is your email, contact us at {phoneNumber}, or",
        "signInLink": "sign in to the Client Portal",
        "title": "Email in use",
        "toRequestAppointment": "to request a new appointment."
      },
      "unableToRequest": {
        "title": "We were unable to request this appointment."
      }
    },
    "baseClient": {
      "addresses": "Address",
      "birthDate": "Date of birth",
      "insuranceInfos": "Insurance information",
      "invalidBirthDate": "Please enter a valid date of birth",
      "sex": "Sex"
    },
    "birthDateRequired": "Date of birth is required",
    "blank": "{description} can't be blank",
    "blankField": "This field can't be blank",
    "cancelReasonRequired": "Please enter a reason for cancellation",
    "card": {
      "cardholderName": "Cardholder's name"
    },
    "channelCustomFields": {
      "referenceId": {
        "invalidFormat": "Please enter an alphanumeric ID",
        "tooLong": "Can't be more than 50 characters"
      }
    },
    "client": {
      "clientRelationships": "Client relationships",
      "email": "Email address",
      "firstName": "First name",
      "lastName": "Last name",
      "phoneNumber": "Phone number",
      "phoneNumberLength": "Phone number must be 10 digits",
      "state": "State"
    },
    "clientContact": {
      "stateRequired": "State is required"
    },
    "clientCouple": {
      "birthDate": "Date of birth",
      "firstName": "First name",
      "invalidBirthDate": "Please enter a valid date of birth",
      "lastName": "Last name",
      "state": "State"
    },
    "clientRelationship": {
      "relatedClient": "Related client"
    },
    "description": "This field",
    "documentRequestContactInfoConnection": {
      "addressCity": "Address city",
      "addressState": "Address state",
      "addressStreet": "Address street",
      "addressZip": "Address ZIP code",
      "birthDate": "Birth date",
      "eligibleInsuranceProviderName": "Insurance provider",
      "emailAddress": "Email address is invalid",
      "emergencyContactEmailAddress": "Emergency contact email is invalid",
      "emergencyContactFirstName": "Emergency contact first name",
      "emergencyContactLastName": "Emergency contact last name",
      "emergencyContactPhoneNumber": "Emergency contact phone",
      "emergencyContactType": "Emergency contact type",
      "firstName": "First name",
      "insuranceCardBackId": "Insurance card back",
      "insuranceCardFrontId": "Insurance card front",
      "insuranceInsuredAddress": "Insured address",
      "insuranceInsuredCity": "Insured city",
      "insuranceInsuredDob": "Insured date of birth",
      "insuranceInsuredFname": "Insured first name",
      "insuranceInsuredLname": "Insured last name",
      "insuranceInsuredPhone": "Insured phone",
      "insuranceInsuredRelation": "Insured relation",
      "insuranceInsuredSex": "Insured sex",
      "insuranceInsuredState": "Insured state",
      "insuranceInsuredZip": "Insured ZIP code",
      "insuranceMemberId": "Insurance member ID",
      "lastName": "Last name",
      "phoneNumber": "Phone number",
      "sex": "Sex"
    },
    "email": {
      "address": "Email address"
    },
    "emailRequired": "Email is required",
    "firstNameRequired": "First name is required",
    "format": {
      "email": "Please enter a valid {description}"
    },
    "inclusion": "{description} must be accepted",
    "insuranceClaim": {
      "clientAcknowledged": "Authorization is required to submit an out-of-network claim"
    },
    "insuranceInfo": {
      "insurancePlan": "Insurance plan",
      "insuredAddress": "Insured address",
      "insuredCity": "Insured city",
      "insuredDob": "Insured date of birth",
      "insuredFname": "Insured first name",
      "insuredLname": "Insured last name",
      "insuredPhone": "Insured phone number",
      "insuredRelation": "Insured relation",
      "insuredState": "Insured state",
      "insuredZip": "Insured ZIP code",
      "memberId": "Member ID"
    },
    "insuranceInfoRequestConnection": {
      "insurancePlan": "Insurance plan",
      "insuredAddress": "Insured address",
      "insuredCity": "Insured city",
      "insuredDob": "Insured date of birth",
      "insuredFname": "Insured first name",
      "insuredLname": "Insured last name",
      "insuredPhone": "Insured phone number",
      "insuredRelation": "Insured relation",
      "insuredState": "Insured state",
      "insuredZip": "Insured ZIP code",
      "memberId": "Member ID"
    },
    "invalidEmail": "This field must be a valid email address",
    "lastNameRequired": "Last name is required",
    "lengthExceeded": "Message exceeds {max} characters",
    "office": {
      "city": "City",
      "state": "State",
      "street": "Street address",
      "zip": "ZIP code"
    },
    "payment": {
      "amount": "Amount",
      "amountGreaterThanBalance": "Amount cannot be greater than total account balance",
      "amountGreaterThanInvoice": "Amount cannot be greater than invoice amount",
      "amountTooSmall": "Amount must be greater than $0.50"
    },
    "phone": {
      "invalid_format": "Phone number is invalid",
      "invalid_length": "This field is the wrong length (should be 10 characters)",
      "required": "Phone is required"
    },
    "presence": "{description} is required",
    "prospectiveClient": {
      "birthDate": "Date of birth",
      "firstName": "First name",
      "invalidBirthDate": "Please enter a valid date of birth",
      "lastName": "Last name",
      "recaptchaRequired": "Complete the reCAPTCHA",
      "recaptchaResponse": "reCAPTCHA",
      "state": "State"
    },
    "reservation": {
      "message": "Message"
    },
    "saveFailedNetworkError": "Your changes could not be saved. Please check your Internet connection and try again.",
    "session": {
      "email": "Email address",
      "pin": "PIN code",
      "pinFormat": "PIN code must be 6 digits",
      "token": "Token"
    },
    "sessionTimeout": {
      "message": "Any progress you made was saved.<br>Go back to dashboard to continue<br>with documents.",
      "title": "Your session timed out"
    },
    "signInToken": {
      "email": "Please enter a valid email address"
    },
    "unauthenticatedAppointment": {
      "cancelReason": "Cancellation reason"
    },
    "wrongLength": "{description} is the wrong length (should be {is} characters)"
  },
  "feedback": {
    "banner": {
      "actions": {
        "goBack": "go back",
        "notNow": "not now",
        "sureHelp": "sure, i'll help",
        "yesExit": "yes, exit"
      },
      "confirmExitMessage": "If you exit without submitting this form, your feedback will not be sent.",
      "confirmExitSubtitle": "Are you sure?",
      "description": "Your response will help SimplePractice improve your Client Portal experience.",
      "effortScore": {
        "optional": "Optional",
        "phiConfirmation": "I confirm that this does not contain any personal health information",
        "ratingQuestion": "Why did you choose this rating?",
        "submit": "submit",
        "veryDifficult": "Very difficult",
        "veryEasy": "Very easy"
      },
      "questionSubtitle": "How easy or difficult is it to use the Client Portal?",
      "subtitle": "Share your feedback?",
      "thankYou": "Thank you for your feedback!",
      "title": "Help us improve"
    }
  },
  "goodFaithEstimate": {
    "introduction": {
      "askProvider": "Ask your health care provider any questions you may have about your estimate and about your right to an estimate when scheduling services.",
      "assistance": "For questions about the estimate, contact your provider.",
      "beforeSigning": "Before signing, ask the provider for a list of what is on the form you are signing.",
      "deductibleWarning": "If you have health insurance but do not plan to use it to pay for an item or service, federal law protects your right to a \"Good Faith Estimate\" of the expected charges.",
      "description": "You have the right to receive a \"Good Faith Estimate\" for the total expected cost of any non-emergency healthcare services, including psychotherapy services.",
      "emergencyCare": "Emergency services from an out-of-network provider or facility.",
      "federalProtection": "Under federal law, your health insurer cannot require you to get prior authorization from the plan before seeking the following:",
      "fullCosts": "Pay full out-of-network costs.",
      "givingUpProtections": "Give up these protections and surprise billing rights.",
      "important": "This Good Faith Estimate shows the costs of items and services that are reasonably expected for your health care needs for an item or service.",
      "inNetworkTreatment": "Treatment by an out-of-network provider at an in-network facility.",
      "nextPage": "Please review the Good Faith Estimate on the next page.",
      "outOfNetworkNotice": "If you receive care from an out-of-network provider or at an out-of-network facility, your health plan might not cover the entire out-of-network cost.",
      "signingWarning": "If you receive a document from your provider to waive your rights, you can refuse to sign. If you do sign, you may:",
      "title": "Surprise Billing Protection Form"
    }
  },
  "home": {
    "header": {
      "existingClient": "Existing Client?"
    },
    "hero": {
      "contact": "Contact",
      "existingClient": "I'm an Existing Client",
      "newClient": "I'm a New Client"
    }
  },
  "information": {
    "careCoordinatorInstructions": "Enter the name, email, and phone number of the person you are requesting an appointment on behalf of. The email and phone number will be used to send appointment confirmations and reminders.",
    "contact": {
      "client": "Client",
      "clientEmail": "Client's Email",
      "clientLegalFirstName": "Client's legal first name",
      "clientLegalLastName": "Client's legal last name",
      "clientPhone": "Client's Phone",
      "email": "Email",
      "isClientMinor": "Is the client a minor?",
      "legalFirstName": "Legal first name",
      "legalLastName": "Legal last name",
      "no": "No",
      "phone": "Phone",
      "tooltips": {
        "leaveBlankEmail": "Leave this blank if the client does not have an email.",
        "leaveBlankPhone": "Leave this blank if the client does not have a phone number.",
        "useInsuranceName": "Use the name on your insurance card."
      },
      "yes": "Yes",
      "you": "You",
      "yourEmail": "Your Email",
      "yourLegalFirstName": "Your legal first name",
      "yourLegalLastName": "Your legal last name",
      "yourMember": "Your member",
      "yourPhone": "Your Phone"
    },
    "couple": {
      "memberPartner": "Member's partner",
      "partner": "Partner",
      "partnerEmail": "Partner's Email",
      "partnerLegalFirstName": "Partner's legal first name",
      "partnerLegalLastName": "Partner's legal last name",
      "partnerPhone": "Partner's Phone",
      "tooltips": {
        "usePartnerInsuranceName": "Use the name on your partner's insurance card."
      }
    }
  },
  "loading": {
    "availability": "Loading Dates and Times...",
    "clinicians": "Loading Clinicians...",
    "information": "Loading...",
    "locations": "Loading Locations...",
    "services": "Loading Services..."
  },
  "location": {
    "milesAway": "miles away",
    "videoLinkNotice": "Video link will be emailed to you 10 minutes before"
  },
  "message": {
    "disclaimers": {
      "reorderedNav": "By submitting the optional information above, you agree that you may be providing protected health information (\"PHI\") to the therapist and team members in their practice. You release SimplePractice (website provider) from any liability associated with disclosure of PHI by the recipient or in transmission.",
      "therapyFinder": "By sending message, you agree that you may be providing personal health information (\"PHI\"). Therapy Finder (website provider) cannot guarantee that such information will remain private, as this is the responsibility of recipient. You release Therapy Finder from any liability associated with disclosure of PHI by recipient."
    }
  },
  "messages": {
    "error": {
      "announcementsLoadFailed": "Please reload and try again",
      "appointmentTimeNoLongerAvailable": "The time you have chosen is no longer available.",
      "cannotAutofillInsuranceInfo": "Cannot autofill insurance info",
      "cardNotSaved": "Card could not be saved",
      "documentNotLoaded": "Document could not be loaded",
      "documentNotSubmitted": "Document could not be submitted",
      "fileNotUploaded": "The file could not be uploaded",
      "insuranceInfoNotSaved": "Insurance information could not be saved",
      "insuranceInfoNotUpdated": "Your information could not be updated",
      "legalAgreementsNotAccepted": "Could not accept the legal agreements",
      "licenseAgreementNotAccepted": "Could not accept the license agreement",
      "prescreenerQuestionsNotLoaded": "Prescreener questions could not be loaded",
      "resourcesLoadFailed": "Error: Failed to load resources",
      "signInRequestFailed": "Could not make Sign In request",
      "signOutFailed": "Could not sign out",
      "websiteSettingsNotSaved": "Website settings could not be saved"
    },
    "info": {
      "reviewDocumentAndSign": "Please review the document and sign below.",
      "signatureRequired": "Signature required"
    },
    "insuranceCard": {
      "confirmUpdateTitle": "Update insurance info using new images?"
    },
    "success": {
      "appointmentCancelled": "Appointment cancelled successfully.",
      "insuranceClaimSubmitted": "Insurance claim created and submitted",
      "insuranceInfoAdded": "Insurance info added",
      "updatesSaved": "Updates successfully saved!"
    }
  },
  "navigation": {
    "backToPreviousStep": "Back to previous step"
  },
  "payment-link": {
    "payment-form": {
      "errors": {
        "contact-provider": "Contact your provider for more information.",
        "payment-could-not-be-made": "Payment could not be made",
        "payment-could-not-be-processed": "Your payment could not be processed"
      }
    }
  },
  "practiceWebsite": {
    "socialMedia": {
      "facebook": "Facebook",
      "instagram": "Instagram",
      "linkedin": "LinkedIn",
      "x": "X",
      "yelp": "Yelp",
      "youtube": "YouTube"
    },
    "specialties": {
      "approaches": "Approaches",
      "fees": "Fees",
      "insuranceAccepted": "Insurance Accepted"
    }
  },
  "session": {
    "signed_out_banner_title": "You have been logged out for security reasons due to being inactive for {minutes} minutes."
  },
  "shared": {
    "accessibility": {
      "helpLabel": "Help",
      "simplePracticeLogo": "SimplePractice logo"
    },
    "actions": {
      "close": "Close",
      "showLess": "Show less",
      "showMore": "Show more"
    },
    "autosave": {
      "multipleTabsError": "Autosave is disabled because you have multiple tabs open for your Client Portal",
      "savedAt": "Autosaved at {time} on {date}"
    },
    "buttons": {
      "chooseFile": "Choose File",
      "remove": "Remove"
    },
    "characters": "characters",
    "clientAppBanner": {
      "continue": "Continue",
      "stayOnWeb": "Stay on Web",
      "subtitle": "Access your care with ease",
      "title": "Use the Client Portal app?"
    },
    "dateRangePicker": {
      "allTimeLabel": "Date Range: All Time",
      "ranges": {
        "allTime": "All Time",
        "last30Days": "Last 30 days",
        "lastMonth": "Last Month",
        "lastYear": "Last Year",
        "thisMonth": "This Month",
        "thisYear": "This Year"
      }
    },
    "errors": {
      "loadingError": "There was an error loading this page. Please check your internet connection, refresh your browser, and try again.",
      "paymentFormError": "Error: Failed to load payment method form"
    },
    "form": {
      "billingZipCode": "Billing ZIP Code",
      "cardNumber": "Card Number",
      "cardNumberPlaceholder": "15 or 16 digit number",
      "cardholderName": "Cardholder's Name",
      "cardholderNamePlaceholder": "Name as shown on the card",
      "expiration": "Expiration",
      "expirationPlaceholder": "mm / yy",
      "securityCode": "Security Code",
      "zipCodePlaceholder": "5-digit number"
    },
    "general": {
      "clientPortal": "Client Portal"
    },
    "legalAgreements": {
      "acceptButton": "I ACCEPT",
      "byAcceptingText": "By accepting, you are agreeing to the"
    },
    "licenseAgreement": {
      "agreeText": "I agree and sign this document",
      "submitButton": "SUBMIT"
    },
    "loading": "Loading...",
    "navigation": {
      "backToSignIn": "Back to Sign in",
      "closeMenu": "Close Menu",
      "openMenu": "Open Menu"
    },
    "questionnaire": {
      "notSigned": "Not signed"
    },
    "security": {
      "paymentsSecured": "Payments secured & encrypted."
    },
    "social": {
      "followUsOn": "Follow Us on"
    },
    "upload": {
      "alternativeText": "or drop files here",
      "buttonText": "Upload Files",
      "downloadHere": "download it here",
      "dragAndDrop": "or drag and drop file",
      "dropFilesHere": "Drop files here to attach",
      "dropText": "Drop files here to attach",
      "fileRestrictions": "Only PDF, JPG, PNG, MP3, M4A, DOC, & CSV files | Max file size of 50MB",
      "fileTypeRestriction": "Only JPG, PNG, & PDF files",
      "fileUploaded": "File Uploaded",
      "invalidText": "Only PDF, JPG, PNG, MP3, M4A, DOC, & CSV files | Max file size of 50MB",
      "noUpload": "(no upload)",
      "previewUnavailable": "Preview is unavailable.",
      "toViewFile": "To view file,",
      "uploadInstructions": "Upload a file or take a picture with your mobile device or webcam.",
      "uploadSuccessful": "Upload Successful",
      "uploading": "Uploading..."
    }
  },
  "signIn": {
    "alreadyAClient": "Already a client?",
    "errors": {
      "invalidCredentials": "Are you sure that's the email on file? Try a different email or contact your practitioner.",
      "needHelp": "Need help?",
      "tooManyEmailRequests": "You've requested a link for the same email address too many times. Wait 5 minutes and try again.",
      "tooManyIpRequests": "You've requested a link too many times. Wait 1 minute and try again."
    },
    "existingClient": "Existing client?",
    "form": {
      "callToRequest": "Call {phone} to request an appointment.",
      "continueWithGoogle": "Continue with Google",
      "email": "Email address",
      "newClient": "New client?",
      "pinInput": "6-digit Pin Code",
      "pinPlaceholder": "Ex: 482927",
      "requestAppointment": "Request appointment",
      "sendLinkButton": "Send Link",
      "separator": "OR",
      "submitButton": "Sign In"
    },
    "loading": {
      "loading": "Loading...",
      "signingIn": "Signing in..."
    },
    "navigation": {
      "backToSignIn": "Back to Sign in",
      "signIn": "Sign In"
    },
    "pin": {
      "form": {
        "description": "Contact your practitioner for a one-time Pin Code you can use to sign in",
        "title": "Sign in via Pin Code"
      },
      "messages": {
        "enterNewPin": "Enter the new Pin Code",
        "here": "here",
        "onceCreated": "once it has been created.",
        "tooManyAttempts": {
          "afterPhone": "to request a new Pin Code.",
          "beforePhone": "You have entered an incorrect Pin Code too many times. Please contact your practitioner by calling"
        }
      }
    },
    "signIn": "Sign In",
    "tips": {
      "checkSpam": {
        "description": "Add {email} to your contact list to prevent these emails from going to the wrong place.",
        "title": "Check your Spam/Junk/Bulk/Updates folder."
      },
      "confirmEmail": {
        "description": "Double check that {email} is associated with your account and spelled correctly.",
        "requestNew": "Request a new link",
        "title": "Confirm you're using the correct email.",
        "wrongEmail": "Did you put in the wrong email?"
      },
      "contactPractitioner": {
        "gotPin": "Got the Pin Code from your practitioner?",
        "signInViaPin": "Sign in via Pin Code",
        "title": "Contact your practitioner for a one-time Pin Code you can use to sign in."
      },
      "title": "Try these tips if you didn't receive a link."
    },
    "toRequestAnAppointment": "To request an appointment,",
    "token": {
      "form": {
        "invalidSubtitle": "Enter your email address and we'll send you a new link to sign in",
        "invalidTitle": "Looks like you need a new link",
        "subtitle": "Enter your email address and we'll send you a password-free link to sign in",
        "title": "Sign in"
      },
      "messages": {
        "checkYourInbox": "Check your inbox",
        "didntGetLink": "Didn't get the link?",
        "expiresIn": "It expires in {time} and can only be used once",
        "linkSent": "If the email address you entered is on file with this practice, a secure sign-in link has been sent.",
        "merged": {
          "description": "You can now use one email to log into Client Portal for everyone you manage.",
          "designatedEmail": "Your designated email login is {email}",
          "signInButton": "Sign in with this email",
          "title": "Making it easier to manage"
        },
        "tryTips": "Try these tips"
      }
    }
  },
  "signature": {
    "create": "Create your signature",
    "display": {
      "ipAddress": "IP address:",
      "pendingSignatureFrom": "Pending signature from",
      "signedBy": "Signed by"
    },
    "edit": "Edit your signature",
    "modal": {
      "cancel": "Cancel",
      "enterFullName": "Enter your full name",
      "helpText": "Updating your information here will be applied to all future signatures.",
      "preview": "Preview",
      "relationshipToClient": "Relationship to client",
      "saveChanges": "Save Changes",
      "successMessage": "Signature Added Successfully.",
      "yourName": "Your name"
    }
  },
  "site": {
    "appointments": {
      "actions": {
        "addToCalendar": "Add to Calendar",
        "callToCancel": "Call to cancel",
        "cancel": "Cancel",
        "directions": "Directions",
        "joinVideo": "Join Video"
      },
      "addToCalendarModal": {
        "addButton": "Add Now",
        "cancelButton": "Cancel",
        "services": {
          "google": "Google Calendar",
          "icloud": "iCloud",
          "outlook": "Outlook"
        },
        "title": "Add to Calendar"
      },
      "cancelModal": {
        "cancelButton": "Yes, Cancel It",
        "keepButton": "No, Keep It",
        "title": "Cancel appointment"
      },
      "empty": {
        "noAppointments": "No appointments."
      },
      "newAppointmentQuestion": "New appointment?",
      "requestNow": "Request Now",
      "requestedBanner": {
        "message": "You will be notified when an appointment has been confirmed.",
        "title": "Requested appointments are still pending approval"
      },
      "status": {
        "canceled": "Canceled",
        "pending": "Pending"
      },
      "tabs": {
        "requested": "Requested",
        "upcoming": "Upcoming"
      }
    },
    "common": {
      "contact": "Contact",
      "signOut": "Sign out"
    },
    "diagnosisTreatmentPlan": {
      "behavioralDefinitions": "Behavioral Definitions",
      "dateTimeAssigned": "Date and Time Assigned to Diagnosis & Treatment Plan",
      "diagnosis": "Diagnosis",
      "goal": "Goal",
      "interventions": "Interventions",
      "objective": "Objective",
      "presentingProblem": "Presenting Problem",
      "treatmentFrequency": "Treatment Frequency"
    },
    "documents": {
      "consentForm": {
        "andContinue": "& Continue",
        "clinicianShared": "Your clinician shared",
        "continue": "Continue",
        "download": "Download",
        "downloadSharedFile": "Download Shared File",
        "submit": "Submit"
      },
      "contactInfo": {
        "addressSection": {
          "address": "Address",
          "cityPlaceholder": "Enter city",
          "stateNotAvailable": "N/A",
          "zipcodePlaceholder": "Zipcode"
        },
        "basicSection": {
          "clientIsMinor": "Client is a minor",
          "legalFirstName": "Legal first name",
          "legalLastName": "Legal last name",
          "legalNameTooltip": "Use the name on your insurance card.",
          "middleName": "Middle name",
          "nicknameLabel": "What name do you go by?",
          "nicknameTooltip": "Used everywhere except for insurance billing."
        },
        "clientInformation": "Client Information",
        "contactSection": {
          "firstName": "First name",
          "lastName": "Last name",
          "relationship": "Relationship"
        },
        "demographicsSection": {
          "birthDate": "Birth date",
          "employmentStatus": "Employment status",
          "genderIdentity": "Gender identity",
          "genderIdentityCharLimit": "Limited to 140 characters",
          "genderIdentityTooltip": "Pronouns, sex, and any other info you'd like your practitioner to know.",
          "noAnswer": "No answer",
          "relationshipStatus": "Relationship status"
        },
        "emailSection": {
          "emailAddress": "Email address",
          "emailType": "Email Type",
          "hint": "Leave blank if minor client does not have their own email.",
          "sendAppointmentReminders": "Yes, send appointment reminders to this email",
          "sendMessagesToEmail": "Yes, it's okay to send messages to this email"
        },
        "emergencyContact": "Emergency Contact",
        "insuranceInformation": "Insurance Information",
        "insuranceSection": {
          "analyzingInsuranceInfo": "Analyzing insurance info...",
          "back": "Back",
          "chooseFileOrDragDrop": "Choose file or drag and drop file",
          "clientRelationshipToInsured": "Client's relationship to insured",
          "doNotRefreshPage": "Please do not refresh or leave this page.",
          "dropFilesHere": "Drop files here to attach",
          "endDate": "End date",
          "fileUploaded": "File Uploaded",
          "front": "Front",
          "groupId": "Group ID",
          "insuranceCard": "Insurance Card",
          "insuranceCompany": "Insurance Company",
          "insuredAddress": "Insured address",
          "insuredBirthDate": "Insured birth date",
          "insuredFirstName": "Insured first name",
          "insuredLastName": "Insured last name",
          "insuredPhoneNumber": "Insured phone number",
          "insuredSexOnPolicy": "What sex is on their insurance policy?",
          "invalidFilesOnly": "Only JPG, PNG, & PDF files",
          "memberId": "Member ID",
          "noUpload": "no upload",
          "ofInsuranceCard": "of Insurance Card",
          "planId": "Plan ID",
          "previewUnavailable": "Preview is unavailable.",
          "searchInsuranceCompany": "Search for your insurance company",
          "sexOnPolicy": "What sex is on your insurance policy?",
          "startDate": "Start date",
          "toViewFile": "To view file,",
          "uploadFileOrTakePicture": "Upload a file or take a picture with your mobile device or webcam.",
          "uploadImageOfCard": "Upload an image of the front and back of your insurance card to keep on file.",
          "uploadImagesAutofill": "Upload insurance card images to automatically fill in insurance info",
          "uploadSuccessful": "Upload Successful",
          "uploading": "Uploading...",
          "viewFileDownload": "download it here"
        },
        "legalGuardian": "Legal Guardian/Responsible party",
        "phoneSection": {
          "dontSendAppointmentReminders": "No, don't send appointment reminders to this number",
          "hint": "Leave blank if minor client does not have their own phone number.",
          "phoneNumber": "Phone number",
          "phoneType": "Phone Type",
          "sendTextAppointmentReminders": "Yes, send text appointment reminders to this number",
          "sendTextMessagesToNumber": "Yes, it's okay to send text messages to this number",
          "sendVoiceAppointmentReminders": "Yes, send voice appointment reminders to this number",
          "sendVoiceMessagesToNumber": "Yes, it's okay to send voice messages to this number"
        },
        "timeZoneSection": {
          "timeZone": "Time Zone"
        }
      },
      "creditCardForm": {
        "noChargeDisclaimer": "Your credit card will not be charged at this point.",
        "saveCreditCard": "Save Credit Card",
        "saveCreditDebitCard": "Save Credit/Debit Card"
      },
      "getStarted": "Get Started",
      "questionnaireForm": {
        "emergencyDisclaimer": "If you or others are in immediate danger or experiencing a medical emergency, call 911 immediately.",
        "modalDescription": "While your clinician has access to the results of the questionnaire once completed, they may not view the results immediately.",
        "modalTitle": "Your responses may not be viewed right away",
        "notice": "Notice",
        "requiredField": "Indicates a required field"
      },
      "shared": {
        "formControls": {
          "andContinue": "& Continue",
          "edit": "Edit",
          "review": "Review",
          "submit": "Submit"
        }
      },
      "table": {
        "completed": "Completed",
        "completedOn": "Completed on",
        "dateCompleted": "Date completed",
        "dateReceived": "Date received",
        "error": {
          "couldNotLoad": "Documents could not be loaded.",
          "retry": "Retry"
        },
        "loading": "Loading Documents...",
        "myUploads": "My Uploads",
        "needsCompletion": "Needs to be completed",
        "receivedOn": "Received on"
      },
      "welcomeTitle": "Welcome to your Client Portal"
    },
    "footer": {
      "cookies": "Cookies",
      "emergencyDisclaimer": "THE CLIENT PORTAL IS NOT TO BE USED FOR EMERGENCY SITUATIONS. IF YOU OR OTHERS ARE IN IMMEDIATE DANGER OR EXPERIENCING A MEDICAL EMERGENCY, CALL 911 IMMEDIATELY.",
      "helpCenter": "Help Center",
      "licenseAgreement": "License Agreement",
      "mainLocation": "Main Location",
      "noSurprisesAct": "No Surprises Act",
      "noSurprisesActFootnote": "You have the right to receive a Good Faith Estimate of what your services may cost.",
      "noticePrivacyPractices": "Notice of Privacy Practices",
      "poweredBy": "Powered By",
      "privacy": "Privacy",
      "socialMedia": "Social Media",
      "terms": "Terms"
    },
    "goodFaithEstimate": {
      "client": "Client",
      "contactPermission": "Contact Permission",
      "contactPerson": "Contact Person",
      "dateProvided": "Date provided",
      "detailsOfServicesFor": "Details of services and items for {practiceName}",
      "diagnosisCode": "Diagnosis code",
      "diagnosisCodes": "Diagnosis codes",
      "diagnosisNotSelected": "Diagnosis not selected",
      "disclaimer": {
        "additionalServices": "Throughout your treatment, the provider may recommend additional items or services as part of your treatment that are not reflected in this estimate. These would need to be scheduled separately with your consent and the understanding that any additional service costs are in addition to the Good Faith Estimate.",
        "agencyDisagrees": "If the agency disagrees with you and agrees with the health care provider or facility, you will have to pay the higher amount.",
        "billedHigher": "If you are billed for more than this Good Faith Estimate, you have the right to dispute the bill.",
        "contactProvider": "You may contact the health care provider or facility listed to let them know the billed charges are higher than the Good Faith Estimate. You can ask them to update the bill to match the Good Faith Estimate, ask to negotiate the bill, or ask if there is financial assistance available.",
        "copySafe": "Keep a copy of this Good Faith Estimate in a safe place or take pictures of it. You may need it if you are billed a higher amount.",
        "disputeFee": "There is a $25 fee to use the dispute process. If the agency reviewing your dispute agrees with you, you will have to pay the price on this Good Faith Estimate.",
        "disputeProcess": "You may also start a dispute resolution process with the U.S. Department of Health and Human Services (HHS). If you choose to use the dispute resolution process, you must start the dispute process within 120 calendar days (about 4 months) of the date on the original bill.",
        "learnMore": "To learn more and get a form to start the process, go to www.cms.gov/nosurprises or call HHS at (800) 985-3059.",
        "moreInfo": "For questions or more information about your right to a Good Faith Estimate or the dispute process, visit www.cms.gov/nosurprises or call (800) 985-3059.",
        "notContract": "The Good Faith Estimate is not a contract between provider and client and does not obligate or require the client to obtain any of the listed services from the provider.",
        "showsCosts": "This Good Faith Estimate shows the costs of items and services that are reasonably expected for your health care needs for an item or service. The estimate is based on information known at the time the estimate was created, and does not include any unknown or unexpected costs that may arise during treatment.",
        "title": "Disclaimer",
        "updatedEstimate": "If your needs change during treatment, your provider should supply a new, updated Good Faith Estimate to reflect the changes to treatment, and the accompanying cost changes."
      },
      "expirationDate": "Expiration date",
      "fee": "Fee",
      "location": "Location",
      "notes": "Notes",
      "provider": "Provider",
      "quantity": "Quantity",
      "serviceDates": "Service dates",
      "serviceDetails": "Service details",
      "subtotal": "Subtotal",
      "title": "Good Faith Estimate for Health Care Goods and Services",
      "totalEstimatedCost": "Total estimated cost"
    },
    "header": {
      "announcements": {
        "ariaLabel": "announcements",
        "empty": "No announcements",
        "removed": "Announcement removed",
        "repliesOff": "Replies are turned off for announcements.",
        "title": "Announcements"
      },
      "hideMenu": "Hide",
      "messages": "Messages",
      "showMenu": "Menu",
      "signedInAs": "Signed in as"
    },
    "localeSwitcher": {
      "ariaLabel": "Language selector. Current language: {language}."
    },
    "nav": {
      "appointments": "Appointments",
      "billingPayments": "Billing & Payments",
      "documents": "Documents"
    },
    "pages": {
      "appointments": "Appointments",
      "documents": "Documents, Forms and Files"
    },
    "paymentLink": {
      "expired": {
        "authenticatedCta": "Make a payment",
        "description": "The payment link you clicked is no longer active. Please contact your practice to request a new link or make a payment in the Client Portal.",
        "imageAlt": "An illustration of a person crossing a street",
        "title": "This payment link has expired",
        "unauthenticatedCta": "Sign in and make a payment"
      },
      "paid": {
        "cta": "Take me home",
        "description": "No further action is required. You're good to go.",
        "imageAlt": "An illustration of butterflies on the beach",
        "title": "Payment received"
      },
      "pay": "Pay",
      "saveCardForFutureUse": "Save card as default for future use",
      "totalPaymentRequested": "Total payment requested"
    }
  }
}], ["es-mx", {
  "availability": {
    "after4pm": "Después de las 4 pm",
    "afternoons": "Tardes",
    "availabilityOn": "Disponibilidad el",
    "before12pm": "Antes de las 12 pm",
    "between12And4pm": "12 pm - 4 pm",
    "change": "Cambiar",
    "displaying": "Mostrando",
    "evenings": "Noches",
    "filterAvailability": "Filtrar disponibilidad",
    "mornings": "Mañanas",
    "showAvailabilityFor": "Mostrar disponibilidad para:",
    "timezoneModal": {
      "cancel": "Cancelar",
      "description": "Selecciona qué zona horaria mostrar para los siguientes horarios de citas.",
      "title": "Cambiar zona horaria",
      "update": "Actualizar"
    },
    "viewingIn": "Viendo en"
  },
  "billing": {
    "actions": {
      "back": "Atrás",
      "cancel": "Cancelar",
      "confirm": "Confirmar",
      "continue": "Continuar",
      "download": "Descargar",
      "pay": "Pagar",
      "payNow": "Pagar ahora",
      "review": "Revisar",
      "submit": "Enviar",
      "submitClaim": "Enviar Reclamo"
    },
    "components": {
      "cardForm": {
        "cardholderName": "Nombre del titular de la tarjeta",
        "namePlaceholder": "Nombre como aparece en la tarjeta"
      },
      "oonBanner": {
        "contactClinician": "Contacta a tu profesional de la salud mental para asistencia adicional",
        "viewStatement": "Ver estado de reembolso del seguro."
      },
      "outOfNetwork": {
        "acknowledgment": "Autorizo a SimplePractice a enviar este reclamo fuera de la red a mi aseguradora en mi nombre. Entiendo que soy responsable del pago de mi cuenta, y SimplePractice no puede aceptar responsabilidad por negociar un acuerdo en un reclamo disputado o responsabilidad financiera por un reclamo denegado.",
        "appointmentInfo": "Información de la cita",
        "appointmentInfoHelp": "Para actualizar la información de tu cita, contacta a tu profesional",
        "back": "Atrás",
        "breadcrumb": "Facturación y Pagos",
        "hideAll": "Ocultar todo",
        "serviceDetails": "Detalles del servicio",
        "showAll": "Mostrar todo",
        "title": "Reclamo fuera de la red",
        "totalFees": "Tarifas Totales",
        "totalPaid": "Total Pagado"
      },
      "paymentMethods": {
        "addNewCard": "Agregar nueva tarjeta",
        "cardsOnFile": "Tarjetas registradas ({count})",
        "changeDefaultCard": "Cambiar tarjeta predeterminada",
        "changeDefaultCardMessage": "Tu {brand} que termina en {last4} se convertirá en tu tarjeta predeterminada.",
        "confirm": "Confirmar",
        "defaultCard": "Tarjeta Predeterminada",
        "defaultCardTooltip": "Todos los pagos se cargarán a esta tarjeta a menos que cambies manualmente el método de pago.",
        "newCard": "+ Nueva Tarjeta",
        "noCards": "Sin tarjetas registradas"
      },
      "paymentModal": {
        "cancel": "Cancelar",
        "makeDefault": "Hacer predeterminada"
      },
      "tables": {
        "amount": "Monto",
        "appointment": "Cita",
        "balance": "Saldo",
        "charges": "Cargos",
        "claimStatus": "Estado del Reclamo",
        "date": "Fecha",
        "details": "Detalles",
        "payments": "Pagos",
        "paymentsTooltip": "Tu profesional de la salud mental ha registrado pagos que has hecho, pero aún no se han aplicado a una factura.",
        "total": "Total",
        "totalBalance": "Saldo Total",
        "totalCharges": "Cargos Totales",
        "type": "Tipo",
        "viewAll": "Ver Todo"
      },
      "tabs": {
        "accountHistory": "Historial de Cuenta",
        "billingDocuments": "Documentos de Facturación",
        "insurance": "Seguro",
        "paymentHistory": "Historial de Pagos",
        "paymentMethods": "Métodos de Pago"
      }
    },
    "coverage": {
      "appointment": "cita",
      "appointments": "citas",
      "willCover": "{channelName} cubrirá {count} {appointments} más"
    },
    "documents": {
      "insurance": "Seguro",
      "insuranceForm": "Formulario de Seguro",
      "insuranceInfo": "Información del seguro",
      "insuranceReimbursementStatements": "Estados de Reembolso de Seguro",
      "invoices": "Facturas",
      "outOfNetworkClaims": "Reclamos fuera de red",
      "receipts": "Recibos",
      "statements": "Estados de Cuenta"
    },
    "empty": {
      "noClaims": "Sin reclamos fuera de la red",
      "noDocuments": "Sin documentos",
      "noHistory": "Sin historial",
      "noInvoices": "Sin facturas",
      "noPendingInvoices": "Sin facturas pendientes."
    },
    "errors": {
      "appointmentBalance": "Pague el saldo de su cita de {amount} para someter el reclamo al seguro",
      "appointmentBalanceHelp": "Para enviar un reclamo fuera de la red, la cita no puede tener un saldo pendiente",
      "claimsNotLoaded": "No se pudieron cargar los reclamos fuera de la red.",
      "couldNotAddCard": "No se pudo agregar una tarjeta",
      "documentsNotLoaded": "No se pudieron cargar los documentos.",
      "historyNotLoaded": "No se pudo cargar el historial.",
      "payBalance": "Pagar saldo de ${amount}",
      "paymentCouldNotBeProcessed": "No se pudo procesar tu pago",
      "technicalIssue": "Hay un problema técnico de nuestro lado. Espera unos minutos, luego intenta de nuevo.",
      "updateInsurance": "Actualiza la información del seguro para continuar",
      "updateInsuranceButton": "Actualizar información del seguro"
    },
    "filters": {
      "allInvoices": "Filtrar: Todas las Facturas",
      "paidInvoices": "Facturas Pagadas",
      "pastDueInvoices": "Facturas Vencidas",
      "unpaidInvoices": "Facturas No Pagadas"
    },
    "financial": {
      "amountDue": "Monto Adeudado",
      "totalBalance": "Saldo Total"
    },
    "forms": {
      "requiredInformation": "*Información requerida"
    },
    "insurance": {
      "company": "Compañía de Seguros",
      "coverageEndDate": "Fecha de Fin de Cobertura",
      "coverageStartDate": "Fecha de Inicio de Cobertura",
      "form": {
        "searchPlaceholder": "Buscar compañía de seguros"
      },
      "groupId": "ID de Grupo",
      "memberId": "ID de Miembro",
      "placeholders": {
        "city": "Ciudad",
        "firstName": "Primer Nombre",
        "groupId": "ID de Grupo (opcional)",
        "lastName": "Apellido",
        "memberId": "ID de Miembro",
        "planId": "ID del Plan (opcional)",
        "state": "Estado",
        "streetAddress": "Dirección",
        "zipCode": "Código Postal"
      },
      "planId": "ID del Plan",
      "policyHolderAddress": "Dirección del Titular de la Póliza",
      "policyHolderBirthDate": "Fecha de Nacimiento del Titular de la Póliza",
      "policyHolderFirstName": "Nombre legal del titular de la póliza",
      "policyHolderLastName": "Apellido legal del titular de la póliza",
      "policyHolderNameTooltip": "Este debe ser su nombre como aparece en la tarjeta del seguro",
      "policyHolderPhone": "Teléfono del Titular de la Póliza",
      "primaryPolicyHolder": "Titular Principal de la Póliza",
      "relations": {
        "other": "Otro",
        "parent": "Padre/Madre",
        "self": "Yo",
        "spouse": "Cónyuge"
      },
      "sex": {
        "female": "Femenino",
        "label": "Sexo del titular de la póliza",
        "male": "Masculino"
      },
      "success": {
        "insuranceUpdated": "Información de seguro guardada exitosamente"
      }
    },
    "messages": {
      "balanceQuestions": "Contacta a tu proveedor si tienes preguntas sobre este balance",
      "loading": "Cargando...",
      "partialPayments": "Ahora puedes hacer pagos parciales hacia tu saldo"
    },
    "pageTitle": "Facturación y Pagos",
    "pages": {
      "addInsurance": "Agregar Seguro",
      "allInsuranceClaims": "Todos los reclamos de seguro fuera de la red",
      "allInvoices": "Todas las Facturas",
      "allReceipts": "Todos los Recibos",
      "allStatements": "Todos los Estados de Cuenta",
      "allSuperbills": "Todos los Estados de Reembolso de Seguro",
      "billingAndPayments": "Facturación y Pagos",
      "insuranceDetails": "Detalles del Seguro",
      "outOfNetworkClaim": "Reclamo Fuera de la Red"
    },
    "paymentMethods": {
      "addNewCard": "Agregar tarjeta",
      "cardAddError": "No se pudo agregar la tarjeta",
      "defaultCard": "Tarjeta",
      "defaultCardAdded": "Tarjeta predeterminada agregada",
      "defaultCardUpdateError": "No se pudo actualizar la tarjeta predeterminada",
      "defaultCardUpdated": "Tarjeta predeterminada actualizada",
      "makeDefault": "Hacer predeterminada",
      "newCardAdded": "Nueva tarjeta agregada",
      "otherAmount": "Otro monto",
      "saveCard": "Guardar",
      "saveNewCard": "Guardar tarjeta",
      "savedCards": "Tarjetas guardadas"
    },
    "paymentModal": {
      "actions": {
        "pay": "Pagar",
        "print": "Imprimir"
      },
      "amount": {
        "creditSuffix": " (crédito)",
        "totalAccountBalance": "Saldo total de la cuenta:"
      },
      "makeCheckPayable": "Hacer cheque pagadero a",
      "makePayment": "Hacer un pago",
      "otherPaymentMethods": "Otros métodos de pago",
      "payWithCard": "Pagar con tarjeta",
      "paymentsSecured": "Pagos asegurados por",
      "selectPaymentAmount": "Seleccionar monto del pago"
    },
    "sections": {
      "invoices": "Facturas",
      "outOfNetworkClaims": "Reclamos fuera de la red",
      "receipts": "Recibos",
      "statements": "Estados de Cuenta",
      "superbills": "Estados de Reembolso de Seguro"
    },
    "states": {
      "fileClaim": "Someter un reclamo a tu compañía de seguros",
      "loading": "Cargando...",
      "loadingClaims": "Cargando Reclamos...",
      "loadingHistory": "Cargando Historial...",
      "preparingClaim": "Preparando reclamo... Esto puede tomar hasta un minuto.",
      "retry": "Reintentar",
      "submittingClaim": "Enviando reclamo... Esto puede tomar hasta un minuto.",
      "totalBalance": "Saldo Total",
      "unableToLoad": "No se pueden cargar métodos de pago adicionales",
      "viewClaim": "Ver reclamo",
      "youHaveCredit": "Tienes un crédito de"
    },
    "success": {
      "contactProviderForInfo": "Contacta a tu proveedor para más información.",
      "paymentCouldNotBeMade": "No se pudo realizar el pago",
      "paymentCouldNotBeProcessedTitle": "No se pudo procesar tu pago",
      "paymentMadeSuccessfully": "Pago realizado con éxito."
    }
  },
  "booking": {
    "actions": {
      "continueAndReview": "Continuar y Revisar",
      "more": "MÁS",
      "next": "Siguiente",
      "requestAppointment": "Solicitar Cita",
      "skip": "Omitir"
    },
    "calendar": {
      "afternoon": "Tarde",
      "days": {
        "friday": "Vie",
        "monday": "Lun",
        "saturday": "Sáb",
        "sunday": "Dom",
        "thursday": "Jue",
        "tuesday": "Mar",
        "wednesday": "Mié"
      },
      "evening": "Noche",
      "months": {
        "april": "Abril",
        "august": "Agosto",
        "december": "Diciembre",
        "february": "Febrero",
        "january": "Enero",
        "july": "Julio",
        "june": "Junio",
        "march": "Marzo",
        "may": "Mayo",
        "november": "Noviembre",
        "october": "Octubre",
        "september": "Septiembre"
      },
      "morning": "Mañana"
    },
    "clientType": {
      "careCoordinator": {
        "member": "Mi afiliado",
        "memberAndPartner": "Mi afiliado y mi pareja",
        "memberOnBehalf": "Mi afiliado en nombre de alguien más"
      },
      "contact": "Alguien más",
      "couple": "Mi pareja y yo",
      "me": "Yo",
      "messages": {
        "allTypes": "Puedes solicitar esta cita para ti, en nombre de alguien más, o para ti y tu pareja. Por favor elige a continuación.",
        "careCoordinator": "Por favor elige de las opciones a continuación.",
        "clientContact": "Puedes solicitar esta cita para ti o en nombre de alguien más. Por favor elige a continuación.",
        "clientCouple": "Puedes solicitar esta cita para ti, o para ti y tu pareja. Por favor elige a continuación.",
        "contactCouple": "Puedes solicitar esta cita en nombre de alguien más o para ti y tu pareja. Por favor elige a continuación."
      },
      "select": "Seleccionar",
      "title": "¿Para quién es esta cita?"
    },
    "date": {
      "availability": "Disponibilidad en {month}",
      "noAvailability": "Lo sentimos, no hay disponibilidad para este servicio en la ubicación que has seleccionado.",
      "tryDifferentLocation": "Prueba una ubicación diferente"
    },
    "information": {
      "appointmentRequestsWillBeConfirmed": "Las solicitudes de citas serán confirmadas por el consultorio.",
      "careCoordinatorInstructions": "Ingresa el nombre, correo electrónico y número de teléfono de la persona para la cual solicitas una cita. El correo electrónico y número de teléfono serán utilizados para enviar confirmaciones de citas y recordatorios.",
      "contactInformation": "Información de contacto",
      "dateOfBirth": "Fecha de nacimiento",
      "email": "Correo electrónico",
      "emergencyNotice": "Si tú u otros están en peligro inmediato o experimentando una emergencia médica, llama al 911 inmediatamente",
      "howDoYouPlanToPay": "¿Cómo planeas pagar la atención?",
      "insurance": {
        "backOfInsuranceCard": "Reverso de la tarjeta de seguro",
        "downloadHere": "descárgalo aquí",
        "dropFilesHere": "Suelta archivos aquí para adjuntar",
        "frontOfInsuranceCard": "Frente de la tarjeta de seguro",
        "insuranceCard": "Tarjeta de seguro",
        "onlyFileTypes": "Solo archivos JPG, PNG y PDF",
        "previewUnavailable": "Vista previa no disponible.",
        "remove": "Eliminar",
        "toViewFile": "Para ver el archivo,",
        "uploadInsuranceCard": "Sube una imagen del frente y reverso de tu tarjeta de seguro",
        "uploadSuccessful": "Carga Exitosa"
      },
      "insuranceOption": "Seguro",
      "legalFirstName": "Nombre legal",
      "legalLastName": "Apellido legal",
      "nameYouGoBy": "Nombre por el que te conocen",
      "noAnswer": "Sin respuesta",
      "outOfPocket": "De mi bolsillo",
      "phone": "Teléfono",
      "thisWillOnlyBeShared": "Esto solo será compartido con el consultorio",
      "tooltips": {
        "useInsuranceName": "Usa el nombre de tu tarjeta de seguro."
      }
    },
    "location": {
      "select": "Seleccionar"
    },
    "message": {
      "additionalInfo": "Información adicional (opcional)",
      "additionalInfoSubtitle": "Comparte más detalles con este profesional de la salud mental para ayudarle a responder a tu solicitud. Solo comparte lo que te sientas cómodo compartiendo. Tus respuestas se transmitirán de forma segura.",
      "disclaimers": {
        "reorderedNav": "Al enviar la información opcional anterior, aceptas que puedes estar proporcionando información de salud protegida (\"ISP\") al terapeuta y miembros del equipo en su consultorio. Liberas a SimplePractice (proveedor del sitio web) de cualquier responsabilidad asociada con la divulgación de ISP por parte del destinatario o en la transmisión.",
        "therapyFinder": "Al enviar mensaje, aceptas que puedes estar proporcionando información personal de salud (\"IPS\"). Therapy Finder (proveedor del sitio web) no puede garantizar que dicha información permanezca privada, ya que esto es responsabilidad del destinatario. Liberas a Therapy Finder de cualquier responsabilidad asociada con la divulgación de IPS por parte del destinatario."
      },
      "emergencyNotice": "En caso de emergencia, no solicites una cita en línea. Si estás experimentando una emergencia médica, o estás pensando en suicidarte o hacerte daño a ti mismo o a otros, llama al 911 inmediatamente o a otro número de emergencia aplicable.",
      "fireWarning": "Hazle saber a tu terapeuta si has sido afectado por los incendios en Los Ángeles",
      "forExample": "Por ejemplo: en qué te gustaría enfocarte, preguntas sobre seguros o pagos, etc.",
      "isThereAnythingElse": "¿Hay algo más que te gustaría que el proveedor supiera?",
      "limitedTo600Characters": "Limitado a 600 caracteres",
      "message": "Mensaje",
      "optional": "Opcional",
      "selectAllThatApply": "Selecciona todas las que apliquen",
      "selectUpTo3": "Selecciona hasta 3 de las siguientes opciones",
      "useThisSpace": "Usa este espacio para compartir un poco sobre lo que te trajo aquí hoy, en qué te gustaría enfocarte, hacer preguntas sobre seguros o pagos, o incluir cualquier otra cosa que quieras que el terapeuta sepa.",
      "whatIsYourHistory": "¿Cuál es tu historial con la salud mental?",
      "whatKindOfCare": "¿Qué tipo de atención estás buscando?",
      "whyAreYouSeekingCare": "¿Por qué buscas atención?"
    },
    "prescreener": {
      "categories": {
        "administrative": "Administrativo",
        "billingAndPayment": "Facturación y pago",
        "clientPreferences": "Preferencias del cliente",
        "demographics": "Datos demográficos",
        "reasonForCare": "Motivo de la consulta"
      },
      "insurance": {
        "back": {
          "ofYourCard": "Reverso de tu tarjeta",
          "title": "Reverso de la tarjeta de seguro"
        },
        "front": {
          "ofYourCard": "Anverso de tu tarjeta",
          "title": "Anverso de la tarjeta de seguro"
        }
      },
      "legalWarning": "Si tú u otra persona están en peligro inmediato o experimentan una emergencia médica, llama al 911 de inmediato.\n",
      "phiNotice": "Al completar y enviar la información opcional anterior, aceptas que podrías estar proporcionando información médica protegida (\"PHI\"). Monarch (el proveedor del sitio web) no puede garantizar que dicha información se mantenga privada. En la máxima medida permitida por la ley, liberas a Monarch de cualquier responsabilidad asociada con la divulgación de PHI, incluida, entre otras, la realizada por el destinatario o durante la transmisión. Ten en cuenta que la información que envíes puede ser visible para los miembros del equipo de este consultorio.\n",
      "questions": {
        "file": {
          "forDesktop": {
            "primary": "Choose file",
            "secondary": " or drag and drop file"
          },
          "forMobile": {
            "primary": "Upload a file",
            "secondary": " or take a picture"
          }
        },
        "sex": {
          "subtext": "Para la verificación del seguro"
        },
        "state": {
          "subtext": "Selecciona el estado en el que vives"
        }
      },
      "validations": {
        "dateOfBirth": "Ingresa una fecha de nacimiento válida",
        "file": "Sube el anverso y reverso de tu tarjeta de seguro",
        "maxLength": "Limitado a {maxLength} caracteres",
        "multiselect": {
          "default": "Este campo no puede estar vacío. Selecciona todas las opciones que correspondan",
          "hint": "Este campo no puede estar vacío."
        },
        "select": "Este campo no puede estar vacío",
        "state": "Este campo no puede estar vacío. Selecciona el estado en el que vives",
        "string": "Este campo no puede estar vacío",
        "text": "Este campo no puede estar vacío"
      }
    },
    "requestAnAppointment": "Solicitar una cita",
    "review": {
      "completedStep": "Paso completado",
      "dateTime": "Fecha y Hora",
      "location": "Ubicación",
      "service": "Servicio",
      "subtitle": "Nota: Las solicitudes de citas serán confirmadas por el consultorio. Toca Solicitar Cita abajo para terminar.",
      "title": "¡Casi terminamos!"
    },
    "service": {
      "recommended": "Recomendado",
      "select": "Seleccionar"
    },
    "steps": {
      "clientType": "Seleccionar cliente",
      "clientTypes": {
        "contact": "Contacto",
        "couple": "Pareja",
        "individual": "Individual"
      },
      "clinician": "Elegir profesional de la salud mental",
      "completedTitles": {
        "client": "Cliente",
        "clinician": "Profesional de la Salud Mental",
        "contactInformation": "Información de contacto",
        "dateTime": "Fecha y hora",
        "location": "Ubicación",
        "memberInformation": "Informacion del afiliado",
        "service": "Servicio"
      },
      "condensed": {
        "additionalInfo": "Información adicional",
        "appointmentInfo": "Información de la cita",
        "optional": "(opcional)",
        "prescreener": "Prescreener",
        "reasonForVisit": "Motivo de la visita",
        "yourInfo": "Tu información"
      },
      "contactInformation": "Información de contacto",
      "date": "Seleccionar fecha y hora",
      "externalDetails": "Detalles externos",
      "intakeDocuments": "Documentos de admisión",
      "loading": {
        "availability": "disponibilidad",
        "clinicians": "profesionales de la salud mental",
        "locations": "ubicaciones",
        "services": "servicios"
      },
      "location": "Seleccionar ubicación",
      "message": "Mensaje",
      "requestCancelled": "Solicitud cancelada",
      "requestSent": "Solicitud enviada",
      "reviewConfirm": "Revisar y confirmar",
      "service": "Seleccionar servicio",
      "unavailable": "No disponible"
    },
    "unavailable": {
      "callNow": "Llama ahora para programar una sesión: {phone}.",
      "contactDirectly": "Comunicate directamente con tu profesional de la salud mental para agendar tu cita.",
      "problem": "Hubo un problema completando tu solicitud.",
      "title": "Contacta a tu profesional de la salud mental"
    },
    "widget": {
      "signIn": {
        "alreadyClient": "¿Ya eres cliente?",
        "signIn": "Iniciar sesión",
        "toRequest": "Para solicitar una cita,"
      },
      "title": "Solicitar una cita"
    }
  },
  "cancelled": {
    "appointmentCancelled": "Tu cita ha sido cancelada.",
    "bookNewAppointment": "Reservar una nueva cita"
  },
  "channelFields": {
    "externalReferenceId": "ID de referencia externa",
    "referenceTooltip": "Incluye un ID de referencia para asociar solicitudes con un sistema externo. Ignora si no tienes un número de referencia",
    "subtitle": "La información a continuación puede usarse para asociar tus solicitudes de citas con un sistema externo.",
    "title": "Ingresa opcionalmente un número de referencia externo"
  },
  "channelUploads": {
    "acceptedFileTypes": "Tipos de archivo aceptados: pdf, doc, docx",
    "dragAndDrop": "o arrastra y suelta",
    "dropText": "Suelta archivos aquí para adjuntar",
    "invalidText": "Selección inválida, por favor sube un pdf, doc o docx",
    "subtitle": "Completa y sube el formulario de admisión a continuación para acelerar el proceso de admisión del profesional de la salud mental.",
    "title": "Opcionalmente sube documentos para compartir con el profesional de la salud mental.",
    "uploadFile": "Subir archivo"
  },
  "clientAttendance": {
    "actions": {
      "addToCalendar": "Agregar al Calendario",
      "cancelAppointment": "Cancelar Cita",
      "confirmAttendance": "Sí, estaré ahí"
    },
    "alert": {
      "title": "Ha ocurrido un error"
    },
    "errors": {
      "appointmentDeleted": "Esta cita ha sido eliminada o no existe",
      "connectionError": "Por favor verifica tu conexión y actualiza la página",
      "linkExpired": "Este enlace ya no es válido. La cita ya pasó."
    },
    "labels": {
      "options": "Opciones:",
      "when": "Cuándo:",
      "where": "Dónde:",
      "with": "Con:"
    },
    "modals": {
      "cancel": {
        "confirmButton": "Sí, Cancelar",
        "confirmationMessage": "¿Estás seguro de que deseas cancelar? Después de cancelar, no se podrán realizar más cambios a esta cita.",
        "maxChars": "{count} caracteres máximo",
        "reasonLabel": "Motivo de la cancelación",
        "reasonPlaceholder": "Ej. Tuve un conflicto de trabajo.",
        "title": "Cancelar Cita",
        "windowPassed": "La ventana de cancelación ha pasado. Por favor llama al {phone} para cancelar."
      },
      "status": {
        "dismiss": "Cerrar"
      }
    },
    "notices": {
      "telehealthLink": "El enlace para unirte a tu cita de Telesalud estará incluido."
    },
    "status": {
      "appointmentCancelled": "Cita Cancelada",
      "appointmentConfirmed": "Cita Confirmada"
    }
  },
  "confirmation": {
    "addToCalendar": "Agregar al Calendario",
    "apple": "Apple",
    "bookNewAppointment": "Reservar una nueva cita",
    "cancelAppointment": "Cancelar Cita",
    "contact": "Contacto",
    "done": "Hecho",
    "google": "Google",
    "outlook": "Outlook",
    "thankYou": {
      "appointmentRequested": "Tu cita ha sido solicitada",
      "appointmentRequestedSubmessage": "Hemos enviado una confirmación y los detalles a tu correo electrónico.",
      "careCoordinatorConfirmation": "Te enviaremos una confirmación después de que tu cita haya sido confirmada.",
      "careCoordinatorRequestSent": "Tu solicitud de cita ha sido enviada.",
      "existingClientConfirmation": "Tu cita no está confirmada hasta que recibas un correo electrónico diciendo que tu solicitud ha sido aceptada.",
      "newClientConfirmation": "Recibirás un correo electrónico con los detalles de tu cita solicitada. Tu cita no está confirmada hasta que recibas otro correo electrónico diciendo que tu solicitud ha sido aceptada."
    },
    "what": "Qué",
    "when": "Cuándo",
    "where": "Dónde",
    "who": "Quién",
    "with": "Con"
  },
  "consent": {
    "contactConsent": "Al solicitar una cita, consientes a ser contactado por este consultorio o SimplePractice por correo electrónico, teléfono, correo de voz o mensaje de texto.",
    "dataProcessingConsent": "Al enviar este formulario, aceptas el procesamiento de tu información personal sensible, que puede incluir información de salud protegida (ISP). Esta información puede ser vista por miembros del equipo en este consultorio.",
    "requestConfirmation": "Las solicitudes de citas serán confirmadas por el consultorio"
  },
  "contact": {
    "clientInfo": "Información del cliente",
    "completedStep": "Paso completado",
    "dateOfBirth": "Fecha de nacimiento",
    "email": "Correo electrónico",
    "emergencyWarning": "Si usted u otras personas están en peligro inmediato o experimentan una emergencia médica, llame al 911 de inmediato.",
    "firstName": "Nombre",
    "gender": "Género",
    "isClientMinor": "¿El cliente es menor de edad?",
    "isThereAnything": "¿Hay algo más que quieras compartir?",
    "lastName": "Apellido",
    "limitedTo600": "Limitado a 600 caracteres",
    "messageExample": "Por ejemplo: en qué te gustaría enfocarte, preguntas sobre seguros o pagos, etc.",
    "messageSentTo": "Tu mensaje ha sido enviado a {practiceName}",
    "nameYouGoBy": "Nombre por el cual te conocen",
    "no": "No",
    "partnerInfo": "Información de la pareja",
    "phone": "Teléfono",
    "select": "Seleccionar",
    "selectState": "Selecciona el estado donde vives",
    "sendMessage": "Enviar mensaje",
    "state": "Estado",
    "whoReceivingCare": "¿Quién recibiría la atención?",
    "yes": "Sí",
    "yourInfo": "Tu información"
  },
  "dateCalendar": {
    "nextMonth": "Siguiente mes",
    "previousMonth": "Mes anterior"
  },
  "documents": {
    "emptyState": {
      "noPendingDocuments": "No hay documentos pendientes en este momento."
    }
  },
  "emc": {
    "away_message_customizer": {
      "customize": "Customize",
      "description": "Let your clients know to expect a delayed response when they message you in the Client Portal.",
      "input_label": "Message",
      "input_placeholder": "Start note...",
      "learn_more": "Learn more",
      "message_required": "A message is required",
      "retry_button": "Retry",
      "save_button": "Save",
      "title": "Customize Your Away Message",
      "unsaved_changes": "You have unsaved changes",
      "update_failed": "Something went wrong on our end.",
      "update_success": "Away message updated successfully"
    },
    "away_status": {
      "false": "off",
      "indicator": "(Away)",
      "status_text_prefix": "Away message to clients is",
      "true": "on",
      "update_failed": "Failed to update your away status. Please try again.",
      "update_success": "Away message turned {status}"
    },
    "contact_list_item": {
      "select_aria_label": "Select {userNames} to start a conversation"
    },
    "contacts_page": {
      "clear_search": "Clear search",
      "infinity_loader_label": "Load more contacts",
      "list": "Contact list",
      "loading": "Loading contacts",
      "new_message": "New message",
      "no_contacts_found": "No contacts found",
      "recent_conversations": "Recent conversations",
      "search_help_text": "Search for contacts by name to start a new conversation",
      "search_input_label": "To:",
      "search_placeholder": "Search for a client, a contact, or a team member"
    },
    "device_offline_error": "Your device seems to be offline, so sending messages won't work at the moment. We'll keep trying to reconnect, or you can retry.",
    "disabled_conversation_error": "Something went wrong on our end. Please refresh the page.",
    "draft_indicator": "[Draft]",
    "empty_list_header": "Welcome to Secure Messaging",
    "empty_list_text": "You don't have any conversations yet",
    "general_error": "Something went wrong on our end. Please try again.",
    "message_placeholder": "Send a message",
    "message_status": {
      "delivered": "Delivered",
      "failed": "Failed to send. Click to retry",
      "sending": "Sending..."
    },
    "navigation": {
      "conversation_list": "Secure messages {amount, plural, =0 {} other {({amount})}}"
    },
    "new_line_hint": {
      "effect": "to add a new line",
      "keys": "Shift + Return"
    },
    "read_at": {
      "before_today": "Read {date} at {time}",
      "before_today_couple": "Read by {name} {date} at {time}",
      "today": "Read at {time}",
      "today_couple": "Read by {name} at {time}"
    },
    "retry_connection": "Retry connection",
    "send": "Send",
    "start_conversation_callout": "Start a secure conversation with {name}",
    "start_conversation_header": "Start a secure conversation",
    "truncated_system_message": {
      "footer": "Your Account Owner can request a Data Export at any time from their account, contact them for more information.",
      "text": "Your Messaging history with this client prior to {date} is available via the Practice Data Export. {footer}"
    },
    "truncated_text": {
      "show_less": "Show less",
      "show_more": "Show more"
    },
    "unread_message_indicator": "Unread message indicator"
  },
  "errors": {
    "403": {
      "message": "Tu cuenta de usuario de SimplePractice no tiene los permisos necesarios para acceder a esta página. Si crees que deberías tener acceso, contacta a tu administrador de cuenta.",
      "title": "No tienes permisos para acceder a esta página."
    },
    "404": {
      "message": "No podemos encontrar la página que buscas, pero podemos ayudarte a encontrar el camino a casa.",
      "messageNoPractice": "No podemos encontrar la página que buscas.",
      "title": "Esta página parece estar perdida"
    },
    "500": {
      "message": "Ocurrió un error inesperado. Hemos sido notificados del error y lo estamos investigando activamente. Esta es una prioridad para resolver. Por favor intenta tu solicitud nuevamente en unos minutos.",
      "title": "Ocurrió un error inesperado del sistema."
    },
    "actions": {
      "errorCode": "Código de error: {code}",
      "retry": "Reintentar",
      "takeHome": "Llévame a casa"
    },
    "appointment": {
      "duplicateEmail": {
        "coupleMessage": "Se encontró una dirección de correo electrónico duplicada. Para solicitar esta cita, por favor ingresa una dirección de correo electrónico única para ti y tu pareja. Si tú y tu pareja comparten un correo electrónico, deja su correo en blanco.",
        "minorMessage": "Se encontró una dirección de correo electrónico duplicada. Para solicitar esta cita, por favor ingresa una dirección de correo electrónico única para ti y el cliente. Si el cliente no tiene su propio correo electrónico o comparten uno, por favor deja el suyo en blanco.",
        "title": "Correo Electrónico Duplicado"
      },
      "emailInUse": {
        "message": "El correo electrónico ya está en uso. Si este es tu correo electrónico,",
        "messageWithPhone": "El correo electrónico ya está en uso. Si este es tu correo electrónico, contáctanos al {phoneNumber}, o",
        "signInLink": "inicia sesión en el Portal del Cliente",
        "title": "Correo electrónico en uso",
        "toRequestAppointment": "para solicitar una nueva cita."
      },
      "unableToRequest": {
        "title": "No pudimos solicitar esta cita."
      }
    },
    "baseClient": {
      "addresses": "Dirección",
      "birthDate": "Fecha de nacimiento",
      "insuranceInfos": "Información de seguro",
      "invalidBirthDate": "Por favor ingresa una fecha de nacimiento válida",
      "sex": "Sexo"
    },
    "birthDateRequired": "La fecha de nacimiento es requerida",
    "blank": "{description} no puede estar en blanco",
    "blankField": "Este campo no puede estar en blanco",
    "cancelReasonRequired": "Por favor ingrese un motivo de cancelación",
    "card": {
      "cardholderName": "Nombre del titular de la tarjeta"
    },
    "channelCustomFields": {
      "referenceId": {
        "invalidFormat": "Ingrese un ID alfanumérico",
        "tooLong": "No puede tener más de 50 caracteres"
      }
    },
    "client": {
      "clientRelationships": "Vínculo con el cliente",
      "email": "Dirección de correo electrónico",
      "firstName": "Nombre",
      "lastName": "Apellido",
      "phoneNumber": "Número de teléfono",
      "phoneNumberLength": "El número de teléfono debe tener 10 dígitos",
      "state": "Estado"
    },
    "clientContact": {
      "stateRequired": "El estado es requerido"
    },
    "clientCouple": {
      "birthDate": "Fecha de nacimiento",
      "firstName": "Nombre",
      "invalidBirthDate": "Por favor ingresa una fecha de nacimiento válida",
      "lastName": "Apellido",
      "state": "Estado"
    },
    "clientRelationship": {
      "relatedClient": "Cliente relacionado"
    },
    "description": "Este campo",
    "documentRequestContactInfoConnection": {
      "addressCity": "Ciudad de dirección",
      "addressState": "Estado de dirección",
      "addressStreet": "Calle de dirección",
      "addressZip": "Código postal de dirección",
      "birthDate": "Fecha de nacimiento",
      "eligibleInsuranceProviderName": "Proveedor de seguro",
      "emailAddress": "Dirección de correo electrónico es inválida",
      "emergencyContactEmailAddress": "Correo de contacto de emergencia es inválido",
      "emergencyContactFirstName": "Primer nombre de contacto de emergencia",
      "emergencyContactLastName": "Apellido de contacto de emergencia",
      "emergencyContactPhoneNumber": "Teléfono de contacto de emergencia",
      "emergencyContactType": "Tipo de contacto de emergencia",
      "firstName": "Primer nombre",
      "insuranceCardBackId": "Reverso de tarjeta de seguro",
      "insuranceCardFrontId": "Frente de tarjeta de seguro",
      "insuranceInsuredAddress": "Dirección del asegurado",
      "insuranceInsuredCity": "Ciudad del asegurado",
      "insuranceInsuredDob": "Fecha de nacimiento del asegurado",
      "insuranceInsuredFname": "Primer nombre del asegurado",
      "insuranceInsuredLname": "Apellido del asegurado",
      "insuranceInsuredPhone": "Teléfono del asegurado",
      "insuranceInsuredRelation": "Relación del asegurado",
      "insuranceInsuredSex": "Sexo del asegurado",
      "insuranceInsuredState": "Estado del asegurado",
      "insuranceInsuredZip": "Código postal del asegurado",
      "insuranceMemberId": "ID de miembro del seguro",
      "lastName": "Apellido",
      "phoneNumber": "Número de teléfono",
      "sex": "Sexo"
    },
    "email": {
      "address": "Dirección de correo electrónico"
    },
    "emailRequired": "El correo electrónico es requerido",
    "firstNameRequired": "El nombre es requerido",
    "format": {
      "email": "Por favor ingresa {description} válido"
    },
    "inclusion": "{description} debe ser aceptado",
    "insuranceClaim": {
      "clientAcknowledged": "Se requiere autorización para enviar una reclamación fuera de la red"
    },
    "insuranceInfo": {
      "insurancePlan": "Plan de seguro",
      "insuredAddress": "Dirección del asegurado",
      "insuredCity": "Ciudad del asegurado",
      "insuredDob": "Fecha de nacimiento del asegurado",
      "insuredFname": "Primer nombre del asegurado",
      "insuredLname": "Apellido del asegurado",
      "insuredPhone": "Teléfono del asegurado",
      "insuredRelation": "Relación del asegurado",
      "insuredState": "Estado del asegurado",
      "insuredZip": "Código postal del asegurado",
      "memberId": "ID de miembro"
    },
    "insuranceInfoRequestConnection": {
      "insurancePlan": "Plan de seguro",
      "insuredAddress": "Dirección del asegurado",
      "insuredCity": "Ciudad del asegurado",
      "insuredDob": "Fecha de nacimiento del asegurado",
      "insuredFname": "Primer nombre del asegurado",
      "insuredLname": "Apellido del asegurado",
      "insuredPhone": "Teléfono del asegurado",
      "insuredRelation": "Relación del asegurado",
      "insuredState": "Estado del asegurado",
      "insuredZip": "Código postal del asegurado",
      "memberId": "ID de miembro"
    },
    "invalidEmail": "Este campo debe ser una dirección de correo electrónico válida",
    "lastNameRequired": "El apellido es requerido",
    "lengthExceeded": "El mensaje excede {max} caracteres",
    "office": {
      "city": "Ciudad",
      "state": "Estado",
      "street": "Dirección",
      "zip": "Código postal"
    },
    "payment": {
      "amount": "Monto",
      "amountGreaterThanBalance": "El monto no puede ser mayor que el saldo total de la cuenta",
      "amountGreaterThanInvoice": "El monto no puede ser mayor que el monto de la factura",
      "amountTooSmall": "El monto debe ser mayor a $0.50"
    },
    "phone": {
      "invalid_format": "El número de teléfono es inválido",
      "invalid_length": "Este campo tiene la longitud incorrecta (debe tener 10 caracteres)",
      "required": "El teléfono es requerido"
    },
    "presence": "{description} es requerido",
    "prospectiveClient": {
      "birthDate": "Fecha de nacimiento",
      "firstName": "Nombre",
      "invalidBirthDate": "Por favor ingresa una fecha de nacimiento válida",
      "lastName": "Apellido",
      "recaptchaRequired": "Completa el reCAPTCHA",
      "recaptchaResponse": "reCAPTCHA",
      "state": "Estado"
    },
    "reservation": {
      "message": "Mensaje"
    },
    "saveFailedNetworkError": "No se pudieron guardar los cambios. Por favor verifica tu conexión a Internet e inténtalo de nuevo.",
    "session": {
      "email": "Dirección de correo electrónico",
      "pin": "Código PIN",
      "pinFormat": "El código PIN debe tener 6 dígitos",
      "token": "Token"
    },
    "sessionTimeout": {
      "message": "Cualquier progreso que hayas hecho fue guardado.<br>Regresa al panel para continuar<br>con los documentos.",
      "title": "Tu sesión expiró"
    },
    "signInToken": {
      "email": "Por favor ingresa una dirección de correo electrónico válida"
    },
    "unauthenticatedAppointment": {
      "cancelReason": "Motivo de cancelación"
    },
    "wrongLength": "{description} tiene la longitud incorrecta (debe tener {is} caracteres)"
  },
  "feedback": {
    "banner": {
      "actions": {
        "goBack": "regresar",
        "notNow": "ahora no",
        "sureHelp": "claro, ayudaré",
        "yesExit": "sí, salir"
      },
      "confirmExitMessage": "Si sales sin enviar este formulario, tu comentario no será enviado.",
      "confirmExitSubtitle": "¿Estás seguro?",
      "description": "Tu respuesta ayudará a SimplePractice a mejorar tu experiencia en el Portal del Cliente.",
      "effortScore": {
        "optional": "Opcional",
        "phiConfirmation": "Confirmo que esto no contiene información personal de salud",
        "ratingQuestion": "¿Por qué elegiste esta calificación?",
        "submit": "enviar",
        "veryDifficult": "Muy difícil",
        "veryEasy": "Muy fácil"
      },
      "questionSubtitle": "¿Qué tan fácil o difícil es usar el Portal del Cliente?",
      "subtitle": "¿Compartes tu opinión?",
      "thankYou": "¡Gracias por tu opinión!",
      "title": "Ayúdanos a mejorar"
    }
  },
  "goodFaithEstimate": {
    "introduction": {
      "askProvider": "Pregunta a tu proveedor de atención médica cualquier duda que tengas sobre tu estimado y sobre tu derecho a un estimado al programar servicios.",
      "assistance": "Para preguntas sobre el estimado, contacta a tu proveedor.",
      "beforeSigning": "Antes de decidir si firmar este formulario, puedes contactar a tu compañía de seguro para encontrar un proveedor o instalación dentro de la red. Si no hay uno, también puedes preguntarle a tu compañía de seguro si pueden hacer un acuerdo con este proveedor o instalación (u otro) para reducir tus costos.",
      "deductibleWarning": "Es posible que tu plan de salud no contabilice lo que pagues para tu deducible ni para tu limite de gastos de bolsillo. Comunicate con tu plan de salud para obtener mas informacion.",
      "description": "Tienes derecho a recibir un \"Estimado de Buena Fe\" del costo total esperado de cualquier servicio de atención médica no urgente, incluidos los servicios de psicoterapia.",
      "emergencyCare": "Servicios de emergencia de un proveedor o instalación fuera de la red.",
      "federalProtection": "Bajo la ley federal, tu aseguradora de salud no puede requerirte que obtengas autorización previa del plan antes de buscar lo siguiente:",
      "fullCosts": "Podrias ser responsable del pago total de los articulos y servicios que recibas facturados.",
      "givingUpProtections": "Renunciar a estas protecciones y derechos de facturación sorpresa.",
      "important": "IMPORTANTE: No estás obligado a firmar este formulario y no deberías firmarlo si no tuviste opción de proveedor de atención médica antes de programar la atención. Puedes elegir recibir atención de un proveedor o instalación en la red de tu plan de salud, lo cual podria costarte menos.",
      "inNetworkTreatment": "Tratamiento por un proveedor fuera de la red en una instalación dentro de la red.",
      "nextPage": "Por favor revisa el Estimado de Buena Fe en la siguiente página.",
      "outOfNetworkNotice": "Si recibes atención de un proveedor fuera de la red o en una instalación fuera de la red, tu plan de salud podría no cubrir todo el costo fuera de la red.",
      "signingWarning": "Si recibes un documento de tu proveedor para renunciar a tus derechos, puedes negarte a firmar. Si firmas, podrías:",
      "title": "Formulario de Protección contra Facturación Sorpresa"
    }
  },
  "home": {
    "header": {
      "existingClient": "¿Cliente Existente?"
    },
    "hero": {
      "contact": "Contacto",
      "existingClient": "Soy un Cliente Existente",
      "newClient": "Soy un Cliente Nuevo"
    }
  },
  "information": {
    "careCoordinatorInstructions": "Ingresa el nombre, correo electrónico y número de teléfono de la persona para la cual solicitas una cita. El correo electrónico y número de teléfono serán utilizados para enviar confirmaciones de citas y recordatorios.",
    "contact": {
      "client": "Cliente",
      "clientEmail": "Correo electrónico del cliente",
      "clientLegalFirstName": "Nombre legal del cliente",
      "clientLegalLastName": "Apellido legal del cliente",
      "clientPhone": "Teléfono del cliente",
      "email": "Correo electrónico",
      "isClientMinor": "¿Es el cliente menor de edad?",
      "legalFirstName": "Primer nombre legal",
      "legalLastName": "apellido legal",
      "no": "No",
      "phone": "Teléfono",
      "tooltips": {
        "leaveBlankEmail": "Deja esto en blanco si el cliente no tiene correo electrónico.",
        "leaveBlankPhone": "Deja esto en blanco si el cliente no tiene número de teléfono.",
        "useInsuranceName": "Usa el nombre en tu tarjeta de seguro."
      },
      "yes": "Sí",
      "you": "Tú",
      "yourEmail": "Tu correo electrónico",
      "yourLegalFirstName": "Tu nombre legal",
      "yourLegalLastName": "Tu apellido legal",
      "yourMember": "Tu miembro",
      "yourPhone": "Tu teléfono"
    },
    "couple": {
      "memberPartner": "Pareja del miembro",
      "partner": "Pareja",
      "partnerEmail": "Correo electrónico de la pareja",
      "partnerLegalFirstName": "Nombre legal de la pareja",
      "partnerLegalLastName": "Apellido legal de la pareja",
      "partnerPhone": "Teléfono de la pareja",
      "tooltips": {
        "usePartnerInsuranceName": "Usa el nombre de la tarjeta de seguro de tu pareja."
      }
    }
  },
  "loading": {
    "availability": "Cargando Fechas y Horarios...",
    "clinicians": "Cargando profesionales de la salud mental...",
    "information": "Cargando...",
    "locations": "Cargando Ubicaciones...",
    "services": "Cargando Servicios..."
  },
  "location": {
    "milesAway": "millas de distancia",
    "videoLinkNotice": "El enlace de video te será enviado por correo electrónico 10 minutos antes"
  },
  "message": {
    "disclaimers": {
      "reorderedNav": "Al enviar la información opcional anterior, aceptas que puedes estar proporcionando información de salud protegida (\"ISP\") al terapeuta y miembros del equipo en su práctica. Liberas a SimplePractice (proveedor del sitio web) de cualquier responsabilidad asociada con la divulgación de ISP por parte del destinatario o en la transmisión.",
      "therapyFinder": "Al enviar mensaje, aceptas que puedes estar proporcionando información personal de salud (\"IPS''). Therapy Finder (proveedor del sitio web) no puede garantizar que dicha información permanezca privada, ya que esto es responsabilidad del destinatario. Liberas a Therapy Finder de cualquier responsabilidad asociada con la divulgación de ISP por parte del destinatario."
    }
  },
  "messages": {
    "error": {
      "announcementsLoadFailed": "Por favor, recarga e inténtalo de nuevo",
      "appointmentTimeNoLongerAvailable": "El horario que elegiste ya no está disponible.",
      "cannotAutofillInsuranceInfo": "No se puede completar automáticamente la información del seguro",
      "cardNotSaved": "No se pudo guardar la tarjeta",
      "documentNotLoaded": "No se pudo cargar el documento",
      "documentNotSubmitted": "No se pudo enviar el documento",
      "fileNotUploaded": "No se pudo cargar el archivo",
      "insuranceInfoNotSaved": "No se pudo guardar la información del seguro",
      "insuranceInfoNotUpdated": "No se pudo actualizar tu información",
      "legalAgreementsNotAccepted": "No se pudieron aceptar los acuerdos legales",
      "licenseAgreementNotAccepted": "No se pudo aceptar el acuerdo de licencia",
      "prescreenerQuestionsNotLoaded": "No se pudieron cargar las preguntas de preselección",
      "resourcesLoadFailed": "Error: No se pudieron cargar los recursos",
      "signInRequestFailed": "No se pudo realizar la solicitud de inicio de sesión",
      "signOutFailed": "No se pudo cerrar sesión",
      "websiteSettingsNotSaved": "No se pudieron guardar los ajustes del sitio web"
    },
    "info": {
      "reviewDocumentAndSign": "Por favor, revisa el documento y firma a continuación.",
      "signatureRequired": "Firma requerida"
    },
    "insuranceCard": {
      "confirmUpdateTitle": "¿Actualizar información del seguro con nuevas imágenes?"
    },
    "success": {
      "appointmentCancelled": "Cita cancelada exitosamente.",
      "insuranceClaimSubmitted": "Reclamo de seguro creado y enviado",
      "insuranceInfoAdded": "Información del seguro añadida",
      "updatesSaved": "¡Actualizaciones guardadas exitosamente!"
    }
  },
  "navigation": {
    "backToPreviousStep": "Volver al paso anterior"
  },
  "payment-link": {
    "payment-form": {
      "errors": {
        "contact-provider": "Comunícate con tu proveedor para más información.",
        "payment-could-not-be-made": "No se pudo realizar el pago",
        "payment-could-not-be-processed": "Tu pago no pudo ser procesado"
      }
    }
  },
  "practiceWebsite": {
    "socialMedia": {
      "facebook": "Facebook",
      "instagram": "Instagram",
      "linkedin": "LinkedIn",
      "x": "X",
      "yelp": "Yelp",
      "youtube": "YouTube"
    },
    "specialties": {
      "approaches": "Enfoques",
      "fees": "Tarifas",
      "insuranceAccepted": "Seguro Aceptado"
    }
  },
  "session": {
    "signed_out_banner_title": "Has sido desconectado por razones de seguridad debido a inactividad durante {minutes} minutos."
  },
  "shared": {
    "accessibility": {
      "helpLabel": "Ayuda",
      "simplePracticeLogo": "Logo de SimplePractice"
    },
    "actions": {
      "close": "Cerrar",
      "showLess": "Mostrar menos",
      "showMore": "Mostrar más"
    },
    "autosave": {
      "multipleTabsError": "El autoguardado está deshabilitado porque tienes múltiples pestañas abiertas de tu Portal del Cliente",
      "savedAt": "Autoguardado a las {time} el {date}"
    },
    "buttons": {
      "chooseFile": "Elegir Archivo",
      "remove": "Eliminar"
    },
    "characters": "caracteres",
    "clientAppBanner": {
      "continue": "Continuar",
      "stayOnWeb": "Quedarse en la web",
      "subtitle": "Accede a tu atención con facilidad",
      "title": "¿Usar el Portal del Cliente?"
    },
    "dateRangePicker": {
      "allTimeLabel": "Rango de Fechas: Todo el Tiempo",
      "ranges": {
        "allTime": "Todo el Tiempo",
        "last30Days": "Últimos 30 días",
        "lastMonth": "Mes Pasado",
        "lastYear": "Año Pasado",
        "thisMonth": "Este Mes",
        "thisYear": "Este Año"
      }
    },
    "errors": {
      "loadingError": "Hubo un error al cargar esta página. Por favor verifica tu conexión a internet, actualiza tu navegador e intenta de nuevo.",
      "paymentFormError": "Error: No se pudo cargar el formulario de método de pago"
    },
    "form": {
      "billingZipCode": "Código Postal de Facturación",
      "cardNumber": "Número de Tarjeta",
      "cardNumberPlaceholder": "Número de 15 o 16 dígitos",
      "cardholderName": "Nombre del Titular",
      "cardholderNamePlaceholder": "Nombre como aparece en la tarjeta",
      "expiration": "Vencimiento",
      "expirationPlaceholder": "mm / aa",
      "securityCode": "Código de Seguridad",
      "zipCodePlaceholder": "Número de 5 dígitos"
    },
    "general": {
      "clientPortal": "Portal del Cliente"
    },
    "legalAgreements": {
      "acceptButton": "ACEPTO",
      "byAcceptingText": "Al aceptar, estás de acuerdo con"
    },
    "licenseAgreement": {
      "agreeText": "Acepto y firmo este documento",
      "submitButton": "ENVIAR"
    },
    "loading": "Cargando...",
    "navigation": {
      "backToSignIn": "Volver a iniciar sesión",
      "closeMenu": "Cerrar Menú",
      "openMenu": "Abrir Menú"
    },
    "questionnaire": {
      "notSigned": "No firmado"
    },
    "security": {
      "paymentsSecured": "Pagos seguros y encriptados."
    },
    "social": {
      "followUsOn": "Síguenos en"
    },
    "upload": {
      "alternativeText": "o suelta archivos aquí",
      "buttonText": "Subir archivos",
      "downloadHere": "descárgalo aquí",
      "dragAndDrop": "o arrastra y suelta el archivo",
      "dropFilesHere": "Suelta archivos aquí para adjuntar",
      "dropText": "Suelta archivos aquí para adjuntar",
      "fileRestrictions": "Solo archivos PDF, JPG, PNG, MP3, M4A, DOC y CSV | Tamaño máximo de archivo de 50MB",
      "fileTypeRestriction": "Solo archivos JPG, PNG y PDF",
      "fileUploaded": "Archivo Cargado",
      "invalidText": "Solo archivos PDF, JPG, PNG, MP3, M4A, DOC y CSV | Tamaño máximo de archivo de 50MB",
      "noUpload": "(sin carga)",
      "previewUnavailable": "Vista previa no disponible.",
      "toViewFile": "Para ver el archivo,",
      "uploadInstructions": "Sube un archivo o toma una foto con tu dispositivo móvil o cámara web.",
      "uploadSuccessful": "Carga Exitosa",
      "uploading": "Cargando..."
    }
  },
  "signIn": {
    "alreadyAClient": "¿Ya eres cliente?",
    "errors": {
      "invalidCredentials": "¿Estás seguro de que ese es el correo electrónico registrado? Prueba con un correo electrónico diferente o contacta a tu profesional.",
      "needHelp": "¿Necesitas ayuda?",
      "tooManyEmailRequests": "Has solicitado un enlace para la misma dirección de correo electrónico demasiadas veces. Espera 5 minutos e inténtalo de nuevo.",
      "tooManyIpRequests": "Has solicitado un enlace demasiadas veces. Espera 1 minuto e inténtalo de nuevo."
    },
    "existingClient": "¿Cliente existente?",
    "form": {
      "callToRequest": "Llame al {phone} para solicitar una cita.",
      "continueWithGoogle": "Continuar con Google",
      "email": "Dirección de correo electrónico",
      "newClient": "¿Cliente nuevo?",
      "pinInput": "Código PIN de 6 dígitos",
      "pinPlaceholder": "Ej: 482927",
      "requestAppointment": "Solicitar cita",
      "sendLinkButton": "Enviar Enlace",
      "separator": "O",
      "submitButton": "Iniciar sesión"
    },
    "loading": {
      "loading": "Cargando...",
      "signingIn": "Iniciando sesión..."
    },
    "navigation": {
      "backToSignIn": "Volver a iniciar sesión",
      "signIn": "Iniciar sesión"
    },
    "pin": {
      "form": {
        "description": "Contacta a tu profesional para obtener un código PIN de un solo uso que puedes usar para iniciar sesión",
        "title": "Iniciar sesión con código PIN"
      },
      "messages": {
        "enterNewPin": "Ingresa el nuevo código PIN",
        "here": "aquí",
        "onceCreated": "una vez que haya sido creado.",
        "tooManyAttempts": {
          "afterPhone": "para solicitar un nuevo código PIN.",
          "beforePhone": "Has ingresado un código PIN incorrecto demasiadas veces. Por favor contacta a tu profesional llamando al"
        }
      }
    },
    "signIn": "Iniciar sesión",
    "tips": {
      "checkSpam": {
        "description": "Agrega {email} a tu lista de contactos para evitar que estos correos vayan al lugar equivocado.",
        "title": "Revisa tu carpeta de Spam/Correo no deseado/Bulk/Actualizaciones."
      },
      "confirmEmail": {
        "description": "Verifica que {email} esté asociado con tu cuenta y esté escrito correctamente.",
        "requestNew": "Solicita un nuevo enlace",
        "title": "Confirma que estás usando el correo electrónico correcto.",
        "wrongEmail": "¿Pusiste el correo electrónico incorrecto?"
      },
      "contactPractitioner": {
        "gotPin": "¿Obtuviste el código PIN de tu profesional?",
        "signInViaPin": "Iniciar sesión con código PIN",
        "title": "Contacta a tu profesional para obtener un código PIN de un solo uso que puedes usar para iniciar sesión."
      },
      "title": "Prueba estos consejos si no recibiste un enlace."
    },
    "toRequestAnAppointment": "Para solicitar una cita,",
    "token": {
      "form": {
        "invalidSubtitle": "Ingresa tu dirección de correo electrónico y te enviaremos un nuevo enlace para iniciar sesión",
        "invalidTitle": "Parece que necesitas un nuevo enlace",
        "subtitle": "Ingresa tu dirección de correo electrónico y te enviaremos un enlace sin contraseña para iniciar sesión",
        "title": "Iniciar sesión"
      },
      "messages": {
        "checkYourInbox": "Revisa tu bandeja de entrada",
        "didntGetLink": "¿No recibiste el enlace?",
        "expiresIn": "Expira en {time} y solo se puede usar una vez",
        "linkSent": "Si la dirección de correo electrónico que ingresaste está en la lista de clientes de este consultorio, se ha enviado un enlace de inicio de sesión seguro.",
        "merged": {
          "description": "Ahora puedes usar un correo electrónico para iniciar sesión en el Portal del Cliente para todos los que administras.",
          "designatedEmail": "Tu correo electrónico designado para iniciar sesión es {email}",
          "signInButton": "Iniciar sesión con este correo electrónico",
          "title": "Haciéndolo más fácil de administrar"
        },
        "tryTips": "Prueba estos consejos"
      }
    }
  },
  "signature": {
    "create": "Crear tu firma",
    "display": {
      "ipAddress": "Dirección IP:",
      "pendingSignatureFrom": "Firma pendiente de",
      "signedBy": "Firmado por"
    },
    "edit": "Editar tu firma",
    "modal": {
      "cancel": "Cancelar",
      "enterFullName": "Ingresa tu nombre completo",
      "helpText": "Actualizar tu información aquí se aplicará a todas las firmas futuras.",
      "preview": "Vista previa",
      "relationshipToClient": "Relación con el cliente",
      "saveChanges": "Guardar cambios",
      "successMessage": "Firma agregada exitosamente.",
      "yourName": "Tu nombre"
    }
  },
  "site": {
    "appointments": {
      "actions": {
        "addToCalendar": "Add to Calendar",
        "callToCancel": "Llamar para cancelar",
        "cancel": "Cancelar",
        "directions": "Direcciones",
        "joinVideo": "Unirse al Video"
      },
      "addToCalendarModal": {
        "addButton": "Agregar Ahora",
        "cancelButton": "Cancelar",
        "services": {
          "google": "Google Calendar",
          "icloud": "iCloud",
          "outlook": "Outlook"
        },
        "title": "Agregar al Calendario"
      },
      "cancelModal": {
        "cancelButton": "Sí, Cancelarla",
        "keepButton": "No, Mantenerla",
        "title": "Cancelar cita"
      },
      "empty": {
        "noAppointments": "No hay citas."
      },
      "newAppointmentQuestion": "¿Nueva cita?",
      "requestNow": "Solicitar Ahora",
      "requestedBanner": {
        "message": "Se te notificará cuando una cita haya sido confirmada.",
        "title": "Las citas solicitadas están pendientes de aprobación"
      },
      "status": {
        "canceled": "Cancelado",
        "pending": "Pendiente"
      },
      "tabs": {
        "requested": "Solicitadas",
        "upcoming": "Próximas"
      }
    },
    "common": {
      "contact": "Contacto",
      "signOut": "Cerrar sesión"
    },
    "diagnosisTreatmentPlan": {
      "behavioralDefinitions": "Definiciones de Comportamiento",
      "dateTimeAssigned": "Fecha y Hora Asignada al Diagnóstico y Plan de Tratamiento",
      "diagnosis": "Diagnóstico",
      "goal": "Objetivo",
      "interventions": "Intervenciones",
      "objective": "Objetivo",
      "presentingProblem": "Problema Presentado",
      "treatmentFrequency": "Frecuencia del Tratamiento"
    },
    "documents": {
      "consentForm": {
        "andContinue": "y Continuar",
        "clinicianShared": "Tu profesional de la salud mental compartió",
        "continue": "Continuar",
        "download": "Descargar",
        "downloadSharedFile": "Descargar Archivo Compartido",
        "submit": "Enviar"
      },
      "contactInfo": {
        "addressSection": {
          "address": "Dirección",
          "cityPlaceholder": "Ingresar ciudad",
          "stateNotAvailable": "N/A",
          "zipcodePlaceholder": "Código postal"
        },
        "basicSection": {
          "clientIsMinor": "El cliente es menor de edad",
          "legalFirstName": "Nombre legal",
          "legalLastName": "Apellido legal",
          "legalNameTooltip": "Usa el nombre que aparece en tu tarjeta de seguro médico.",
          "middleName": "Segundo nombre",
          "nicknameLabel": "¿Qué nombre prefieres usar?",
          "nicknameTooltip": "Se usa en todos lados excepto para facturación de seguro médico."
        },
        "clientInformation": "Información del Cliente",
        "contactSection": {
          "firstName": "Nombre",
          "lastName": "Apellido",
          "relationship": "Relación"
        },
        "demographicsSection": {
          "birthDate": "Fecha de nacimiento",
          "employmentStatus": "Estado laboral",
          "genderIdentity": "Identidad de género",
          "genderIdentityCharLimit": "Limitado a 140 caracteres",
          "genderIdentityTooltip": "Pronombres, sexo y cualquier otra información que te gustaría que tu profesional de la salud mental sepa.",
          "noAnswer": "Sin respuesta",
          "relationshipStatus": "Estado civil"
        },
        "emailSection": {
          "emailAddress": "Dirección de correo electrónico",
          "emailType": "Tipo de Correo Electrónico",
          "hint": "Dejar en blanco si el cliente menor no tiene su propio correo electrónico.",
          "sendAppointmentReminders": "Sí, enviar recordatorios de citas a este correo electrónico",
          "sendMessagesToEmail": "Sí, está bien enviar mensajes a este correo electrónico"
        },
        "emergencyContact": "Contacto de Emergencia",
        "insuranceInformation": "Información del Seguro Médico",
        "insuranceSection": {
          "analyzingInsuranceInfo": "Analizando información del seguro médico...",
          "back": "Reverso",
          "chooseFileOrDragDrop": "Elegir archivo o arrastrar y soltar archivo",
          "clientRelationshipToInsured": "Relación del cliente con el asegurado",
          "doNotRefreshPage": "Por favor no actualices ni salgas de esta página.",
          "dropFilesHere": "Arrastra archivos aquí para adjuntar",
          "endDate": "Fecha de finalización",
          "fileUploaded": "Archivo Subido",
          "front": "Frente",
          "groupId": "ID de Grupo",
          "insuranceCard": "Tarjeta de Seguro Médico",
          "insuranceCompany": "Compañía de Seguro Médico",
          "insuredAddress": "Dirección del asegurado",
          "insuredBirthDate": "Fecha de nacimiento del asegurado",
          "insuredFirstName": "Nombre del asegurado",
          "insuredLastName": "Apellido del asegurado",
          "insuredPhoneNumber": "Número de teléfono del asegurado",
          "insuredSexOnPolicy": "¿Qué sexo aparece en su póliza de seguro médico?",
          "invalidFilesOnly": "Solo archivos JPG, PNG y PDF",
          "memberId": "ID de Miembro",
          "noUpload": "sin subir",
          "ofInsuranceCard": "de la Tarjeta de Seguro Médico",
          "planId": "ID del Plan",
          "previewUnavailable": "Vista previa no disponible.",
          "searchInsuranceCompany": "Buscar tu compañía de seguro médico",
          "sexOnPolicy": "¿Qué sexo aparece en tu póliza de seguro médico?",
          "startDate": "Fecha de inicio",
          "toViewFile": "Para ver el archivo,",
          "uploadFileOrTakePicture": "Sube un archivo o toma una foto con tu dispositivo móvil o cámara web.",
          "uploadImageOfCard": "Sube una imagen del frente y reverso de tu tarjeta de seguro médico para mantener en archivo.",
          "uploadImagesAutofill": "Sube imágenes de la tarjeta de seguro médico para completar automáticamente la información del seguro",
          "uploadSuccessful": "Subida Exitosa",
          "uploading": "Subiendo...",
          "viewFileDownload": "descárgalo aquí"
        },
        "legalGuardian": "Tutor Legal/Parte Responsable",
        "phoneSection": {
          "dontSendAppointmentReminders": "No, no enviar recordatorios de citas a este número",
          "hint": "Dejar en blanco si el cliente menor no tiene su propio número de teléfono.",
          "phoneNumber": "Número de teléfono",
          "phoneType": "Tipo de Teléfono",
          "sendTextAppointmentReminders": "Sí, enviar recordatorios de citas por mensaje de texto a este número",
          "sendTextMessagesToNumber": "Sí, está bien enviar mensajes de texto a este número",
          "sendVoiceAppointmentReminders": "Sí, enviar recordatorios de citas por mensaje de voz a este número",
          "sendVoiceMessagesToNumber": "Sí, está bien enviar mensajes de voz a este número"
        },
        "timeZoneSection": {
          "timeZone": "Zona Horaria"
        }
      },
      "creditCardForm": {
        "noChargeDisclaimer": "Tu tarjeta de crédito no será cobrada en este momento.",
        "saveCreditCard": "Guardar Tarjeta de Crédito",
        "saveCreditDebitCard": "Guardar Tarjeta de Crédito/Débito"
      },
      "getStarted": "Comenzar",
      "questionnaireForm": {
        "emergencyDisclaimer": "Si tú o alguien más está en peligro inmediato o experimentando una emergencia médica, llama al 911 inmediatamente.",
        "modalDescription": "Aunque tu profesional de la salud mental tiene acceso a los resultados del cuestionario una vez completado, es posible que no los vea de inmediato.",
        "modalTitle": "Tus respuestas pueden no ser vistas de inmediato",
        "notice": "Aviso",
        "requiredField": "Indica un campo requerido"
      },
      "shared": {
        "formControls": {
          "andContinue": "y Continuar",
          "edit": "Editar",
          "review": "Revisar",
          "submit": "Enviar"
        }
      },
      "table": {
        "completed": "Completado",
        "completedOn": "Completado el",
        "dateCompleted": "Fecha completada",
        "dateReceived": "Fecha recibida",
        "error": {
          "couldNotLoad": "No se pudieron cargar los documentos.",
          "retry": "Reintentar"
        },
        "loading": "Cargando Documentos...",
        "myUploads": "Mis Cargas",
        "needsCompletion": "Necesita ser completado",
        "receivedOn": "Recibido el"
      },
      "welcomeTitle": "Bienvenido a tu Portal del Cliente"
    },
    "footer": {
      "cookies": "Cookies",
      "emergencyDisclaimer": "EL PORTAL DEL CLIENTE NO DEBE USARSE PARA SITUACIONES DE EMERGENCIA. SI TÚ U OTROS ESTÁN EN PELIGRO INMEDIATO O EXPERIMENTANDO UNA EMERGENCIA MÉDICA, LLAMA AL 911 INMEDIATAMENTE.",
      "helpCenter": "Centro de Ayuda",
      "licenseAgreement": "Acuerdo de Licencia",
      "mainLocation": "Ubicación Principal",
      "noSurprisesAct": "Ley Sin Sorpresas",
      "noSurprisesActFootnote": "Tienes el derecho de recibir un Estimado de Buena Fe de lo que pueden costar tus servicios.",
      "noticePrivacyPractices": "Aviso de Prácticas de Privacidad",
      "poweredBy": "Desarrollado Por",
      "privacy": "Privacidad",
      "socialMedia": "Redes Sociales",
      "terms": "Términos"
    },
    "goodFaithEstimate": {
      "client": "Cliente",
      "contactPermission": "Permiso de Contacto",
      "contactPerson": "Persona de Contacto",
      "dateProvided": "Fecha proporcionada",
      "detailsOfServicesFor": "Detalles de servicios y artículos para {practiceName}",
      "diagnosisCode": "Código de diagnóstico",
      "diagnosisCodes": "Códigos de diagnóstico",
      "diagnosisNotSelected": "Diagnóstico no seleccionado",
      "disclaimer": {
        "additionalServices": "Durante su tratamiento, el proveedor puede recomendar artículos o servicios adicionales como parte de su tratamiento que no se reflejan en esta estimación. Estos deberán programarse por separado con su consentimiento y el entendimiento de que cualquier costo de servicio adicional se suma a la Estimación de Buena Fe.",
        "agencyDisagrees": "Si la agencia no está de acuerdo con usted y está de acuerdo con el proveedor de atención médica o la instalación, tendrá que pagar el monto mayor.",
        "billedHigher": "Si se le factura más que esta Estimación de Buena Fe, tiene derecho a disputar la factura.",
        "contactProvider": "Puede comunicarse con el proveedor de atención médica o la instalación mencionada para informarles que los cargos facturados son más altos que la Estimación de Buena Fe. Puede pedirles que actualicen la factura para que coincida con la Estimación de Buena Fe, pedir negociar la factura o preguntar si hay asistencia financiera disponible.",
        "copySafe": "Guarde una copia de esta Estimación de Buena Fe en un lugar seguro o tome fotografías de ella. Puede necesitarla si se le factura un monto mayor.",
        "disputeFee": "Hay una tarifa de $25 para usar el proceso de disputa. Si la agencia que revisa su disputa está de acuerdo con usted, tendrá que pagar el precio en esta Estimación de Buena Fe.",
        "disputeProcess": "También puede iniciar un proceso de resolución de disputas con el Departamento de Salud y Servicios Humanos de EE. UU. (HHS). Si elige usar el proceso de resolución de disputas, debe iniciar el proceso de disputa dentro de 120 días calendario (aproximadamente 4 meses) de la fecha en la factura original.",
        "learnMore": "Para obtener más información y obtener un formulario para iniciar el proceso, visite www.cms.gov/nosurprises o llame a HHS al (800) 985-3059.",
        "moreInfo": "Para preguntas o más información sobre su derecho a una Estimación de Buena Fe o el proceso de disputa, visite www.cms.gov/nosurprises o llame al (800) 985-3059.",
        "notContract": "La Estimación de Buena Fe no es un contrato entre el proveedor y el cliente y no obliga ni requiere que el cliente obtenga ninguno de los servicios enumerados del proveedor.",
        "showsCosts": "Esta Estimación de Buena Fe muestra los costos de artículos y servicios que se esperan razonablemente para sus necesidades de atención médica para un artículo o servicio. La estimación se basa en información conocida en el momento en que se creó la estimación, y no incluye ningún costo desconocido o inesperado que pueda surgir durante el tratamiento.",
        "title": "Descargo de Responsabilidad",
        "updatedEstimate": "Si sus necesidades cambian durante el tratamiento, su proveedor debe proporcionar una nueva Estimación de Buena Fe actualizada para reflejar los cambios en el tratamiento y los cambios de costo correspondientes."
      },
      "expirationDate": "Fecha de vencimiento",
      "fee": "Tarifa",
      "location": "Ubicación",
      "notes": "Notas",
      "provider": "Proveedor",
      "quantity": "Cantidad",
      "serviceDates": "Fechas de servicio",
      "serviceDetails": "Detalles del servicio",
      "subtotal": "Subtotal",
      "title": "Estimación de Buena Fe para Bienes y Servicios de Atención Médica",
      "totalEstimatedCost": "Costo total estimado"
    },
    "header": {
      "announcements": {
        "ariaLabel": "anuncios",
        "empty": "Sin anuncios",
        "removed": "Anuncio eliminado",
        "repliesOff": "Las respuestas están desactivadas para los anuncios.",
        "title": "Anuncios"
      },
      "hideMenu": "Ocultar",
      "messages": "Mensajes",
      "showMenu": "Menú",
      "signedInAs": "Conectado como"
    },
    "localeSwitcher": {
      "ariaLabel": "Selector de idioma. Idioma actual: {language}."
    },
    "nav": {
      "appointments": "Citas",
      "billingPayments": "Facturación y Pagos",
      "documents": "Documentos"
    },
    "pages": {
      "appointments": "Citas",
      "documents": "Documentos, Formularios y Archivos"
    },
    "paymentLink": {
      "expired": {
        "authenticatedCta": "Hacer un pago",
        "description": "El enlace de pago que seleccionaste ya no está activo. Por favor contacta a tu consultorio para solicitar un nuevo enlace o hacer un pago en el Portal del Cliente.",
        "imageAlt": "Una ilustración de una persona cruzando la calle",
        "title": "Este enlace de pago ha vencido",
        "unauthenticatedCta": "Inicia sesión y haz un pago"
      },
      "paid": {
        "cta": "Llévame a inicio",
        "description": "No se requiere ninguna acción adicional. Todo listo.",
        "imageAlt": "Una ilustración de mariposas en la playa",
        "title": "Pago recibido"
      },
      "pay": "Pagar",
      "saveCardForFutureUse": "Guardar tarjeta como predeterminada para uso futuro",
      "totalPaymentRequested": "Pago total solicitado"
    }
  }
}]];